<template>
  <section v-if="shipment_detail" :key="countRq">
    <validation-observer ref="requestSubmit">
      <div class="shipment_detail_LCL mx-1">
        <div class="title pt-1 pb-1">Customer Information</div>
        <b-card class="b-card-bg">
          <b-row class="px-2">
            <b-col lg="12">
              <b-row>
                <b-col cols="12" lg="4">
                  <validation-provider #default="{ errors }" rules="">
                    <b-form-group>
                      <label class="custom-label-shipment">Service type</label>
                      <Select2
                        :disabled="true"
                        :class="errors.length > 0 ? 'is-invalid' : null"
                        placeholder="Select Service Type"
                        v-model="shipment_detail.service_type"
                        :options="service_types"
                      />
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col cols="12" lg="4">
                  <b-form-group>
                    <label class="custom-label-shipment">Order ID</label>
                    <b-form-input :disabled="true" v-model="bookingId" />
                  </b-form-group>
                </b-col>
                <b-col cols="12" lg="4">
                  <label class="custom-label-shipment">B/L No.</label>
                  <b-form-input
                    class="iuput"
                    v-model="shipment_detail.BL"
                    type="text"
                    placeholder="B/L No."
                  ></b-form-input>
                </b-col>
              </b-row>
            </b-col>
            <b-col lg="12">
              <b-row>
                <b-col cols="12" lg="4">
                  <validation-provider
                    name="Company name"
                    #default="{ errors }"
                    rules="required"
                  >
                    <b-form-group>
                      <label class="custom-label-shipment">Company name </label>

                      <Select4
                        :class="errors.length > 0 ? 'is-invalid' : null"
                        class="select2-v2"
                        rules="required"
                        :disabled="true"
                        placeholder="Enter your customer's name"
                        v-model="shipment_detail.customer_company_id"
                        :options="{
                          isSearch: true,
                          value: 'code',
                          label: 'text',
                          data: company_list,
                          fields: [
                            {
                              field: 'name',
                              label: 'Company name',
                            },
                          ],
                        }"
                      />

                      <small class="text-danger" v-show="errors.length > 0">{{
                        errors[0]
                      }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col cols="12" lg="4">
                  <validation-provider
                    name="Company address"
                    #default="{ errors }"
                    rules="required"
                  >
                    <b-form-group>
                      <label class="custom-label-shipment flex"
                        >Company address
                      </label>

                      <Select4
                        :class="errors.length > 0 ? 'is-invalid' : null"
                        class="select2-v2"
                        placeholder="Enter your customer's address"
                        v-model="companyAddress"
                        :disabled="true"
                        :options="{
                          isSearch: true,
                          value: 'address',
                          label: 'address',
                          data: company_list,
                          fields: [
                            {
                              field: 'address',
                              label: 'Company address',
                            },
                          ],
                        }"
                      />
                      <small class="text-danger" v-show="errors.length > 0">{{
                        errors[0]
                      }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col cols="12" lg="4">
                  <validation-provider
                    name="Tax code"
                    #default="{ errors }"
                    rules="required"
                  >
                    <b-form-group>
                      <label class="custom-label-shipment flex">Tax code</label>

                      <Select4
                        :class="errors.length > 0 ? 'is-invalid' : null"
                        class="select2-v2"
                        :disabled="true"
                        placeholder="Enter your customer's tax code"
                        v-model="companyTax"
                        :options="{
                          isSearch: true,
                          value: 'code',
                          label: 'tax_code',
                          data: company_list,
                          fields: [
                            {
                              field: 'code',
                              label: 'Tax Code',
                            },
                          ],
                        }"
                      />
                      <small class="text-danger" v-show="errors.length > 0">{{
                        errors[0]
                      }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
              </b-row>
            </b-col>
            <b-col lg="12">
              <b-row>
                <b-col cols="12" lg="2" class="pr-0">
                  <validation-provider #default="{ errors }" rules="">
                    <b-form-group>
                      <label class="custom-label-shipment"
                        >To whom will booking be released?
                      </label>
                      <!-- <b-form-input
                    :state="errors.length > 0 ? false : null"
                    v-model="shipment_on_tms.customer_name"
                    placeholder="Customer Contact"
                  /> -->
                      <b-form-input
                        :class="errors.length > 0 ? 'is-invalid' : null"
                        :disabled="true"
                        placeholder="Select Customer"
                        v-model="shipment_detail.customer_id"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col cols="12" lg="2" class="pt-custom">
                  <validation-provider
                    name="Phone"
                    #default="{ errors }"
                    rules=""
                  >
                    <b-form-group>
                      <b-form-input
                        :state="errors.length > 0 ? false : null"
                        :disabled="true"
                        v-model="shipment_detail.customer_phone"
                        placeholder="Phone"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col cols="12" lg="4">
                  <validation-provider
                    name="Email"
                    #default="{ errors }"
                    rules=""
                  >
                    <b-form-group>
                      <label class="custom-label-shipment">Email </label>
                      <b-form-input
                        :state="errors.length > 0 ? false : null"
                        :disabled="true"
                        v-model="shipment_detail.customer_email"
                        placeholder="Email"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
              </b-row>
            </b-col>

            <b-col>
              <b-row>
                <b-col cols="12" lg="2" class="pr-0">
                  <validation-provider
                    name="Contact WR1"
                    #default="{ errors }"
                    rules=""
                  >
                    <b-form-group>
                      <label class="custom-label-shipment">WR1's PIC </label>

                      <Select2
                        :disabled="true"
                        v-model="shipment_detail.sale_id"
                        :options="sales"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col cols="12" lg="2" class="pt-custom">
                  <validation-provider
                    name="Phone"
                    #default="{ errors }"
                    rules=""
                  >
                    <b-form-group>
                      <b-form-input
                        :state="errors.length > 0 ? false : null"
                        :disabled="true"
                        v-model="shipment_detail.sale_phone"
                        placeholder="Phone"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col cols="12" lg="4">
                  <validation-provider
                    name="Email"
                    #default="{ errors }"
                    rules=""
                  >
                    <b-form-group>
                      <label class="custom-label-shipment">Email </label>
                      <b-form-input
                        :state="errors.length > 0 ? false : null"
                        :disabled="true"
                        v-model="shipment_detail.sale_email"
                        placeholder="Email"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>
        <!-- END Order Information -->
        <div class="title custom-title">Routing Details</div>
        <b-card class="b-card-bg">
          <b-row class="px-2">
            <b-col cols="12" lg="4">
              <validation-provider
                name="Quotation No."
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Quotation No.</label>

                  <Select4
                    :disabled="true"
                    class="select2-v2"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    placeholder="Quotation No."
                    v-model="shipment_detail.quotation"
                    :options="{
                      isSearch: true,
                      value: 'id',
                      label: 'id',
                      data: quotations,
                      fields: [
                        {
                          field: 'id',
                          label: 'Quotation No.',
                        },
                        {
                          field: 'exp_date',
                          label: 'Valid to',
                        },
                        {
                          field: 'total_cost',
                          label: 'Total cost',
                        },
                      ],
                    }"
                  />

                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12" lg="4">
              <validation-provider
                name="Handled type"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Handled type</label>
                  <!-- <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="false"
                    placeholder="Handled type"
                    v-model="shipment_detail.shippingType"
                    :options="transport_types"
                  /> -->
                  <!-- <Select4
                        :class="errors.length > 0 ? 'is-invalid' : null"
                        class="select2-v2"
                        placeholder="Handled type"
                        v-model="shipment_detail.shippingType"
                        :disabled="false"
                        :options="{
                          isSearch: true,
                          value: 'id',
                          label: 'name',
                          data: transport_types,
                          fields: [
                            {
                              field: 'name',
                              label: 'Type',
                            },
                          ],
                        }"
                      /> -->
                  <b-form-input :disabled="true" v-model="showTextShipping" />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="4">
              <validation-provider
                name="Shipper"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Booking No.</label>
                  <b-form-input
                    :disabled="readonly"
                    placeholder="Booking No."
                    v-model="shipment_detail.HBL"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="4">
              <validation-provider
                name="Origin Port"
                #default="{ errors }"
                rules="required"
                :key="reload"
              >
                <b-form-group>
                  <label class="flex"
                    >Origin Port <span class="red">*</span></label
                  >
                  <Select4
                    :disabled="true"
                    v-model="shipment_detail.pol_port"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    placeholder="POL/AOL"
                    :options="{
                      isSearch: true,
                      value: 'code',
                      label: 'name',
                      data: ports,
                      fields: [
                        {
                          field: 'code',
                          label: 'Port code',
                        },
                        {
                          field: 'name',
                          label: 'port name',
                        },
                        {
                          field: 'country_code',
                          label: 'Country',
                        },
                      ],
                    }"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="4">
              <validation-provider
                name="Transit Port"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Transit Port</label>

                  <Select4
                    :disabled="true"
                    class="select2-v2"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    placeholder="Transit Port"
                    v-model="shipment_detail.transit_port"
                    :options="{
                      isSearch: true,
                      value: 'code',
                      label: 'name',
                      data: ports,
                      fields: [
                        {
                          field: 'code',
                          label: 'Port code',
                        },
                        {
                          field: 'name',
                          label: 'port name',
                        },
                        {
                          field: 'country_code',
                          label: 'country_code',
                        },
                      ],
                    }"
                  />

                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="4">
              <validation-provider
                name="Delivery Port"
                #default="{ errors }"
                rules="required"
                :key="reload"
              >
                <b-form-group>
                  <label class="flex"
                    >Delivery Port <span class="red">*</span></label
                  >

                  <Select4
                    :disabled="true"
                    v-model="shipment_detail.pod_port"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    placeholder="POD/AOD"
                    :options="{
                      isSearch: true,
                      value: 'code',
                      label: 'name',
                      data: ports,
                      fields: [
                        {
                          field: 'code',
                          label: 'Port code',
                        },
                        {
                          field: 'name',
                          label: 'Port Name',
                        },
                        {
                          field: 'country_code',
                          label: 'Country',
                        },
                      ],
                    }"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="4">
              <validation-provider
                name="Carrier"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Carrier</label>

                  <Select4
                    v-model="shipment_detail.shipping_line"
                    :class="[
                      errors.length > 0 ? 'is-invalid' : null,
                      readonly == true ? 'remove' : '',
                    ]"
                    placeholder="Carrier"
                    :disabled="readonly"
                    @reload="loadShippingType"
                    :options="{
                      isSearch: true,
                      isReload: true,
                      value: 'id',
                      label: 'text',
                      data: shipping_lines,
                      fields: [
                        { field: 'code', label: 'Code' },
                        { field: 'name', label: 'Shipping Line' },
                      ],
                    }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="4">
              <validation-provider
                name="Shipper"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Vessel/Voyage</label>
                  <b-form-input
                    :disabled="readonly"
                    placeholder="Vessel/Voyage"
                    v-model="shipment_detail.vessel"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="4">
              <validation-provider
                name="Place of stuffing"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Place of stuffing</label>
                  <div class="d-flex align-items-center">
                    <Select4
                      v-model="shipment_detail.place_of_stuffing"
                      :classProp="errors.length > 0 ? 'is-invalid' : null"
                      placeholder="Place of stuffing"
                      :disabled="readonly"
                      @reload="loadLocations"
                      :options="{
                        isSearch: true,
                        isReload: true,
                        value: 'id',
                        label: 'abbreviations',
                        data: locations,
                        fields: [
                          { field: 'abbreviations', label: 'Abbreviations' },
                          { field: 'name', label: 'Location' },
                          {
                            field: 'address',
                            label: 'Address',
                          },
                        ],
                      }"
                    />
                  </div>
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="4">
              <validation-provider
                name="Shipper"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Shipper </label>
                  <div class="d-flex">
                    <Select3
                      v-model="shipment_detail.shipper"
                      :disabled="readonly"
                      isReload
                      @select="
                        ({ name, Address }) => {
                          shipment_detail.shipper_name = name;
                          shipment_detail.shipper_address = Address;
                        }
                      "
                      :options="{
                        value: 'id',
                        label: 'name',
                        url: 'masterData?data=ShipperConsignee',
                        fields: [
                          { field: 'name', label: 'Name' },
                          {
                            field: 'Address',
                            label: 'Address',
                          },
                        ],
                      }"
                    />
                  </div>

                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="4">
              <validation-provider
                name="Consignee"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Consignee </label>

                  <Select3
                    v-model="shipment_detail.consignee"
                    isReload
                    :disabled="readonly"
                    @select="
                      ({ name, Address }) => {
                        shipment_detail.consignee_name = name;
                        shipment_detail.consignee_address = Address;
                      }
                    "
                    :options="{
                      value: 'id',
                      label: 'name',
                      url: 'masterData?data=ShipperConsignee',
                      fields: [
                        { field: 'name', label: 'Name' },
                        {
                          field: 'Address',
                          label: 'Address',
                        },
                      ],
                    }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="4">
              <validation-provider
                name="Company"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label>Agent </label>

                  <Select4
                    v-model="shipment_detail.agent"
                    :disabled="readonly"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    placeholder="Select Company"
                    @reload="loadCompany"
                    :options="{
                      isSearch: true,
                      isReload: true,
                      value: 'code',
                      label: 'text',
                      data: companyItems,
                      fields: [
                        { field: 'code', label: 'Tax Code' },

                        { field: 'name', label: 'Name' },
                        {
                          field: 'acronym',
                          label: 'Acronym',
                        },
                      ],
                    }"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
        </b-card>
        <div class="title custom-title">Sailing Schedule</div>
        <b-card class="b-card-bg">
          <b-row class="px-2">
            <b-col cols="12" lg="4">
              <validation-provider
                name="Cargo ready"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label class="flex"
                    >Cargo ready <span class="red">*</span>
                  </label>

                  <b-row>
                    <b-col lg="8" class="pr-0">
                      <date-picker
                        :disabled="readonly"
                        ref="datePicker"
                        v-model="shipment_detail.cargo_ready_date"
                        type="date"
                        title-format="DD/MM/YY"
                        time-title-format="DD/MM/YY"
                        placeholder="Select date"
                        format="DD/MM/YY"
                        class="w-full"
                        value-type="format"
                      >
                      </date-picker>
                    </b-col>
                    <b-col lg="4">
                      <date-picker
                        :disabled="readonly"
                        v-model="shipment_detail.cargo_ready_time"
                        ref="datePicker"
                        type="time"
                        title-format="HH:mm"
                        time-title-format="HH:mm"
                        placeholder="Select time"
                        format="HH:mm"
                        class="w-full"
                        value-type="format"
                      >
                      </date-picker>
                    </b-col>
                  </b-row>

                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12" lg="4">
              <b-form-group>
                <label>ETD</label>
                <date-picker
                  :disabled="readonly"
                  v-model="shipment_detail.etd"
                  ref="datePicker"
                  type="date"
                  title-format="DD/MM/YY"
                  time-title-format="DD/MM/YY"
                  placeholder="Select date"
                  format="DD/MM/YY"
                  class="w-full"
                  value-type="format"
                >
                </date-picker>
              </b-form-group>
            </b-col>

            <b-col cols="12" lg="4">
              <b-form-group>
                <label>ETA</label>
                <date-picker
                  :disabled="readonly"
                  v-model="shipment_detail.eta"
                  ref="datePicker"
                  type="date"
                  title-format="DD/MM/YY"
                  time-title-format="DD/MM/YY"
                  placeholder="Select date"
                  format="DD/MM/YY"
                  class="w-full border-none"
                  value-type="format"
                >
                </date-picker>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <label class="custom-label-shipment">Cargo closing time</label>
              <b-row>
                <b-col class="pr-0" lg="8">
                  <date-picker
                    :disabled="readonly"
                    ref="datePicker"
                    v-model="shipment_detail.cargo_closing_date"
                    type="date"
                    title-format="DD/MM/YY"
                    time-title-format="DD/MM/YY"
                    placeholder="Select date"
                    format="DD/MM/YY"
                    class="w-full"
                    value-type="format"
                  >
                  </date-picker>
                </b-col>
                <b-col lg="4">
                  <date-picker
                    :disabled="readonly"
                    v-model="shipment_detail.cargo_closing_time"
                    ref="datePicker"
                    type="time"
                    title-format="HH:mm"
                    time-title-format="HH:mm"
                    placeholder="Select time"
                    format="HH:mm"
                    class="w-full"
                    value-type="format"
                  >
                  </date-picker>
                </b-col>
              </b-row>
            </b-col>
            <b-col lg="4">
              <label class="custom-label-shipment">Doc closing time</label>
              <b-row>
                <b-col class="pr-0" lg="8">
                  <date-picker
                    :disabled="readonly"
                    ref="datePicker"
                    v-model="shipment_detail.doc_cut_off_date"
                    type="date"
                    title-format="DD/MM/YY"
                    time-title-format="DD/MM/YY"
                    placeholder="Select date"
                    format="DD/MM/YY"
                    class="w-full"
                    value-type="format"
                  >
                  </date-picker>
                </b-col>
                <b-col lg="4">
                  <date-picker
                    :disabled="readonly"
                    v-model="shipment_detail.doc_cut_off_time"
                    ref="datePicker"
                    type="time"
                    title-format="HH:mm"
                    time-title-format="HH:mm"
                    placeholder="Select time"
                    format="HH:mm"
                    class="w-full"
                    value-type="format"
                  >
                  </date-picker>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>
        <div class="title custom-title">Cargo Details</div>
        <div class="cargo-detail">
          <div v-for="item in shipment_detail.showAddMore" :key="item.id">
            <b-card class="b-card-bg bg-cargo">
              <div v-if="item.hasDelete && !readonly" class="custom-delete">
                <b-img
                  width="35px"
                  @click="handleDeleteCargo(item.id)"
                  :src="iconRemove"
                  alt="logo"
                />
              </div>
              <b-row class="px-2">
                <b-col
                  cols="12"
                  lg="12"
                  v-for="item2 in item.showAddMoreLine"
                  :key="item2.id"
                >
                  <b-row>
                    <b-col class="custom-grid">
                      <validation-provider
                        name="No. of packages"
                        #default="{ errors }"
                        rules="required|minNumber:0"
                      >
                        <b-form-group>
                          <label class="flex"
                            >No. of packages
                            <div class="red">*</div>
                          </label>

                          <b-form-input
                            :disabled="readonly"
                            class="iuput"
                            v-model="item2.packages"
                            type="number"
                            placeholder="No. of packages"
                            required
                            @input="updatePackages(item)"
                          ></b-form-input>
                          <small
                            class="text-danger"
                            v-show="errors.length > 0"
                            >{{ errors[0] }}</small
                          >
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                    <b-col class="custom-grid">
                      <validation-provider
                        name="Package type"
                        #default="{ errors }"
                        rules="required"
                      >
                        <b-form-group>
                          <label class="flex"
                            >Package type
                            <div class="red">*</div>
                          </label>

                          <Select2
                            :disabled="readonly"
                            :class="errors.length > 0 ? 'is-invalid' : null"
                            placeholder="Package type"
                            v-model="item2.package_type"
                            :options="
                              cont_types.filter((i) => i.group === 'packaging')
                            "
                          />
                          <small
                            class="text-danger"
                            v-show="errors.length > 0"
                            >{{ errors[0] }}</small
                          >
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                    <b-col class="custom-grid">
                      <validation-provider
                        name=" Gross weight"
                        #default="{ errors }"
                        rules="required|minNumber:0"
                      >
                        <b-form-group>
                          <label class="flex"
                            >Gross weight (kgs)
                            <div class="red">*</div>
                          </label>

                          <b-form-input
                            :disabled="readonly"
                            class="iuput"
                            v-model="item2.gross_weight"
                            type="number"
                            placeholder="Gross weight (kgs)"
                            required
                            @input="updateGrossWeight(item)"
                          ></b-form-input>
                          <small
                            class="text-danger"
                            v-show="errors.length > 0"
                            >{{ errors[0] }}</small
                          >
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                    <b-col class="custom-grid">
                      <validation-provider
                        name="Volume"
                        #default="{ errors }"
                        rules="required|minNumber:0"
                      >
                        <b-form-group>
                          <label class="flex"
                            >Volume (cbm)
                            <div class="red">*</div>
                          </label>

                          <b-form-input
                            :disabled="readonly"
                            @input="updateVolume(item)"
                            v-model="item2.volume"
                            class="iuput"
                            type="number"
                            placeholder="Volume (cbm)"
                            required
                          ></b-form-input>
                          <small
                            class="text-danger"
                            v-show="errors.length > 0"
                            >{{ errors[0] }}</small
                          >
                        </b-form-group>
                      </validation-provider>
                    </b-col>

                    <b-col class="custom-grid">
                          <label>Dimension (cm)</label>

                          <div class="flex">
                            <validation-provider
                              name="Dimension"
                              #default="{ errors }"
                              rules="minNumber:0"
                            >
                              <b-form-group>
                                <b-form-input
                                  :disabled="readonly"
                                  class="iuput"
                                  v-model="item2.dimension.lenght"
                                  type="number"
                                  placeholder="L (cm)"
                                  required
                                ></b-form-input>

                                <small
                                  class="text-danger"
                                  v-show="errors.length > 0"
                                  >{{ errors[0] }}</small
                                >
                              </b-form-group>
                            </validation-provider>

                            <validation-provider
                              name="Dimension"
                              #default="{ errors }"
                              rules="minNumber:0"
                            >
                              <b-form-group>
                                <b-form-input
                                  :disabled="readonly"
                                  class="iuput"
                                  v-model="item2.dimension.width"
                                  type="number"
                                  placeholder="W (cm)"
                                  required
                                ></b-form-input>
                                <small
                                  class="text-danger"
                                  v-show="errors.length > 0"
                                  >{{ errors[0] }}</small
                                >
                              </b-form-group>
                            </validation-provider>
                            <validation-provider
                              name="Dimension"
                              #default="{ errors }"
                              rules="minNumber:0"
                            >
                              <b-form-group>
                                <b-form-input
                                  :disabled="readonly"
                                  class="iuput"
                                  v-model="item2.dimension.height"
                                  type="number"
                                  placeholder="H (cm)"
                                  required
                                ></b-form-input>
                                <small
                                  class="text-danger"
                                  v-show="errors.length > 0"
                                  >{{ errors[0] }}</small
                                >
                              </b-form-group>
                            </validation-provider>
                          </div>
                        </b-col>
                 
                    <b-col class="flex items-center mt-10">
                      <div
                        v-if="!item2.hasDelete && !readonly"
                        class="custom-add-line"
                      >
                        <b-img
                          width="30px"
                          @click="handleAddLine(item.id)"
                          :src="iconAdd"
                          alt="logo"
                        />
                      </div>
                      <div
                        v-if="item2.hasDelete && !readonly"
                        class="custom-add-line"
                      >
                        <b-img
                          width="30px"
                          @click="handleDeleteLine(item.id, item2.id)"
                          :src="remove"
                          alt="logo"
                        />
                      </div>
                    </b-col>
                  </b-row>
                </b-col>

                <b-col cols="12" lg="12">
                  <b-row v-if="shipment_detail.inland">
                    <b-col cols="6">
                      <validation-provider
                        name="Container Type"
                        #default="{ errors }"
                        rules="required"
                      >
                        <b-form-group>
                          <label class="flex"
                            >Truck Type
                            <div class="red">*</div></label
                          >
                          <Select2
                            :class="errors.length > 0 ? 'is-invalid' : null"
                            :disabled="readonly"
                            placeholder="Truck Type"
                            :settings="{
                              allowClear: true,
                            }"
                            v-model="item.truck_type"
                            :options="
                              cont_types.filter((i) => i.group === 'van truck')
                            "
                          />
                          <small
                            class="text-danger"
                            v-show="errors.length > 0"
                            >{{ errors[0] }}</small
                          >
                        </b-form-group>
                      </validation-provider>
                    </b-col>

                    <b-col cols="6">
                      <validation-provider name="TruckId" #default="{ errors }">
                        <b-form-group>
                          <label class="flex"
                            >Truck Id <span class="red">*</span></label
                          >
                          <div class="customTotal">
                            {{ item.lclLine3[0].truckId }}
                          </div>

                          <small
                            class="text-danger"
                            v-show="errors.length > 0"
                            >{{ errors[0] }}</small
                          >
                        </b-form-group>
                      </validation-provider>
                    </b-col>

                    <b-col cols="12" lg="3">
                      <b-form-group>
                        <label class="custom-label-shipment flex"
                          >Pick up address
                          <span class="red">*</span>
                        </label>

                        <Select4
                          v-model="item.lclLine3[0].pickup_location"
                          :disabled="true"
                          :options="{
                            isSearch: true,
                            value: 'id',
                            label: 'text',
                            data: locations,
                            fields: [
                              {
                                field: 'abbreviations',
                                label: 'Abbreviations',
                              },
                              {
                                field: 'name',
                                label: 'Location',
                              },
                              {
                                field: 'address',
                                label: 'Address',
                              },
                            ],
                          }"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col lg="3">
                      <label class="custom-label-shipment">Pick up date</label>

                      <b-form-group>
                        <b-form-input
                          disabled
                          v-model="item.lclLine3[0].pickup_date"
                        />
                      </b-form-group>
                    </b-col>

                    <b-col lg="3">
                      <b-form-group>
                        <label class="custom-label-shipment flex"
                          >Delivery address
                          <span class="red">*</span>
                        </label>

                        <Select4
                          v-model="item.lclLine3[0].delivery_location"
                          :disabled="true"
                          :options="{
                            isSearch: true,
                            value: 'id',
                            label: 'text',
                            data: locations,
                            fields: [
                              {
                                field: 'abbreviations',
                                label: 'Abbreviations',
                              },
                              {
                                field: 'name',
                                label: 'Location',
                              },
                              {
                                field: 'address',
                                label: 'Address',
                              },
                            ],
                          }"
                        />
                      </b-form-group>
                    </b-col>

                    <b-col lg="3">
                      <label class="custom-label-shipment">Delivery date</label>

                      <b-form-group>
                        <b-form-input
                          disabled
                          v-model="item.lclLine3[0].delivery_date"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col class="custom-grid">
                  <validation-provider
                    name="Commodity type"
                    #default="{ errors }"
                    rules="required"
                  >
                    <b-form-group>
                      <label class="flex"
                        >Commodity type <span class="red">*</span></label
                      >

                      <Select2
                        :disabled="readonly"
                        :class="errors.length > 0 ? 'is-invalid' : null"
                        placeholder="Commodity"
                        v-model="item.commodity_type"
                        :options="goods_types"
                      />
                      <small class="text-danger" v-show="errors.length > 0">{{
                        errors[0]
                      }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col class="custom-grid">
                  <validation-provider
                    name="Commodity"
                    #default="{ errors }"
                    rules="required"
                  >
                    <b-form-group>
                      <label class="flex"
                        >Commodity <span class="red">*</span></label
                      >

                      <b-form-input
                        :disabled="readonly"
                        class="iuput"
                        v-model="item.commodity"
                        type="text"
                        placeholder="Commodity"
                        required
                      ></b-form-input>
                      <small class="text-danger" v-show="errors.length > 0">{{
                        errors[0]
                      }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col class="custom-grid">
                  <validation-provider
                    name="Total packages"
                    #default="{ errors }"
                  >
                    <b-form-group>
                      <label class="flex"
                        >Total packages <span class="red">*</span></label
                      >
                      <div class="customTotal">
                        {{ item.total_packages.toLocaleString() }}
                      </div>
                      <small class="text-danger" v-show="errors.length > 0">{{
                        errors[0]
                      }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col class="custom-grid">
                  <validation-provider
                    name="Total gross weight"
                    #default="{ errors }"
                  >
                    <b-form-group>
                      <label class="flex"
                        >Total gross weight (kgs)
                        <span class="red">*</span></label
                      >
                      <div class="customTotal">
                        {{ item.gross_weight_total.toLocaleString() }}
                      </div>
                      <small class="text-danger" v-show="errors.length > 0">{{
                        errors[0]
                      }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col class="custom-grid">
                  <validation-provider
                    name="Total volume"
                    #default="{ errors }"
                  >
                    <b-form-group>
                      <label class="flex"
                        >Total volume (cbm) <span class="red">*</span></label
                      >
                      <div class="customTotal">
                        {{ item.volume_total.toLocaleString() }}
                      </div>

                      <small class="text-danger" v-show="errors.length > 0">{{
                        errors[0]
                      }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
              </b-row>
            </b-card>
          </div>
          <!-- <b-card class="add-more-cargo" v-if="!this.readonly">
            <div @click="handleAddCargo" class="select-add">
              <div class="flex items-center">
                <b-img width="30px" :src="iconAdd" alt="logo" />
                <div class="mx-1">Add more cargo</div>
              </div>
            </div>
          </b-card> -->
        </div>

        <b-row class="mt-custom">
          <b-col lg="4">
            <b-row>
              <b-col cols="12 ">
                <div class="title flex">
                  Freight Terms
                  <div class="red mr-2">*</div>
                  <small
                    v-if="
                      !this.shipment_detail.collect &&
                      !this.shipment_detail.prepaid
                    "
                    class="text-danger"
                    >Please select at least one checkbox.</small
                  >
                </div>
              </b-col>
            </b-row>

            <b-card class="card b-card-bg">
              <b-row class="px-2 custom-row-freight py-custom">
                <b-col cols="12" lg="6">
                  <div class="container-checkbox">
                    <b-form-group>
                      <input
                        :disabled="readonly"
                        type="checkbox"
                        class="custom-checkbox-new"
                        v-model="shipment_detail.prepaid"
                        @change="handleChange(1)"
                      />
                    </b-form-group>

                    <div>
                      <div class="text-black">Prepaid</div>
                    </div>
                  </div>
                </b-col>
                <b-col cols="12" lg="6">
                  <div class="container-checkbox">
                    <b-form-group>
                      <input
                        :disabled="readonly"
                        type="checkbox"
                        class="custom-checkbox-new"
                        v-model="shipment_detail.collect"
                        @change="handleChange(2)"
                      />
                    </b-form-group>

                    <div>
                      <div class="text-black">Collect</div>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-card>
          </b-col>

          <b-col lg="8">
            <b-row>
              <b-col cols="6">
                <div class="title flex">
                  Remarkable
                  <div class="red mr-2">*</div>
                  <small
                    v-if="
                      !this.shipment_detail.stack_able &&
                      !this.shipment_detail.non_stack_able &&
                      !this.shipment_detail.rotatable
                    "
                    class="text-danger"
                    >Please select at least one checkbox.</small
                  >
                </div>
              </b-col>
            </b-row>
            <b-card class="b-card-bg">
              <b-row class="px-2 custom-row">
                <div class="container-checkbox">
                  <input
                    :disabled="readonly"
                    type="checkbox"
                    class="custom-checkbox-new"
                    v-model="shipment_detail.stack_able"
                    @change="handleChangeRemark(1)"
                  />

                  <div>
                    <div class="text-black">Stackable</div>
                  </div>
                </div>

                <div class="container-checkbox">
                  <input
                    :disabled="readonly"
                    type="checkbox"
                    class="custom-checkbox-new"
                    v-model="shipment_detail.non_stack_able"
                    @change="handleChangeRemark(2)"
                  />

                  <div>
                    <div class="text-black">Nonstackable</div>
                  </div>
                </div>

                <div class="container-checkbox">
                  <input
                    :disabled="readonly"
                    type="checkbox"
                    class="custom-checkbox-new"
                    v-model="shipment_detail.rotatable"
                    @change="handleChangeRemark(3)"
                  />

                  <div>
                    <div class="text-black">Rotatable</div>
                  </div>
                </div>

                <div class="container-checkbox">
                  <input
                    :disabled="readonly"
                    type="checkbox"
                    class="custom-checkbox-new"
                    v-model="shipment_detail.oversize"
                  />

                  <div>
                    <div class="text-black">Oversize</div>
                    <div>Length>4m/package</div>
                  </div>
                </div>

                <div class="container-checkbox">
                  <input
                    :disabled="readonly"
                    type="checkbox"
                    class="custom-checkbox-new"
                    v-model="shipment_detail.overweight"
                  />

                  <div>
                    <div class="text-black">Overweight</div>
                    <div>>3tons/package</div>
                  </div>
                </div>
              </b-row>
              <b-row> </b-row>
            </b-card>
          </b-col>
        </b-row>
        <div class="additional-service">
          <b-row lg="12">
            <b-col cols="6" lg="12">
              <div class="title">Additional Service</div>
            </b-col>
          </b-row>
          <b-card class="b-card-bg w-full">
            <b-row lg="12" class="px-2 custom-list-additional">
              <b-col cols="6" lg="4">
                <div class="container-checkbox">
                  <input
                    :disabled="readonly"
                    type="checkbox"
                    class="custom-checkbox-new"
                    v-model="shipment_detail.has_customs"
                  />
                  <div>
                    <div class="text-black">Customs service</div>
                  </div>
                </div>
              </b-col>
              <b-col cols="6" lg="4">
                <div class="container-checkbox">
                  <input
                    :disabled="readonly"
                    type="checkbox"
                    class="custom-checkbox-new"
                    v-model="shipment_detail.door_service"
                    @change="handleChangeAdditional"
                  />

                  <div>
                    <div class="text-black">Door service</div>
                  </div>
                </div>
              </b-col>
              <b-col cols="6" lg="4">
                <div class="container-checkbox">
                  <input
                    :disabled="readonly || shipment_detail.door_service"
                    type="checkbox"
                    class="custom-checkbox-new"
                    v-model="shipment_detail.inland"
                    @change="handleChangeAdditional"
                  />

                  <div>
                    <div class="text-black">Inland trucking in Vietnam</div>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row v-if="shipment_detail.has_customs">
              <div class="titleCustom mt-2">Customs Declaration</div>
            </b-row>
            <b-row class="px-2 mt-2" v-if="shipment_detail.has_customs">
              <b-col cols="6" lg="4">
                <b-row>
                  <b-col
                    v-if="shipment_detail.custom_service_other === false"
                    lg="9"
                  >
                    <validation-provider
                      name="Customs type"
                      #default="{ errors }"
                      rules=""
                    >
                      <b-form-group>
                        <label>Customs type</label>

                        <Select2
                          :disabled="readonly"
                          placeholder="Customs type"
                          v-model="shipment_detail.customs_type"
                          :options="customs_types"
                        />
                        <small class="text-danger" v-show="errors.length > 0">{{
                          errors[0]
                        }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col
                    v-if="shipment_detail.custom_service_other === true"
                    lg="9"
                  >
                    <validation-provider
                      name="Customs type"
                      #default="{ errors }"
                      rules=""
                    >
                      <b-form-group>
                        <label>Customs type</label>

                        <b-form-input
                          :disabled="readonly"
                          class="iuput"
                          v-model="shipment_detail.customs_type_input"
                          type="text"
                          placeholder="Customs type"
                          required
                        ></b-form-input>
                        <small class="text-danger" v-show="errors.length > 0">{{
                          errors[0]
                        }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col lg="3" class="flex items-center mt-1">
                    <div class="container-checkbox mt-other">
                      <input
                        :disabled="readonly"
                        type="checkbox"
                        class="custom-checkbox-new"
                        v-model="shipment_detail.custom_service_other"
                      />

                      <div>
                        <div class="text-black">Other</div>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="6" lg="4">
                <validation-provider
                  name="custom place"
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <label>Place of Customs declaration</label>

                    <b-form-input
                      :disabled="readonly"
                      class="iuput"
                      v-model="shipment_detail.custom_place"
                      type="text"
                      placeholder="Place of Customs declaration"
                      required
                    ></b-form-input>
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="6" lg="4">
                <validation-provider
                  name="HS Code"
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <label>HS Code</label>

                    <b-form-input
                      :disabled="readonly"
                      class="iuput"
                      v-model="shipment_detail.custom_hs_code"
                      type="text"
                      placeholder="HS Code"
                      required
                    ></b-form-input>
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row v-if="shipment_detail.door_service">
              <div class="titleCustom mt-2">Door service</div>
            </b-row>
            <b-row class="px-2 mt-2" v-if="shipment_detail.door_service">
              <b-col cols="6" lg="5">
                <validation-provider
                  name="Pick up address"
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <label class="flex"
                      >Pick up address <span class="red">*</span></label
                    >

                    <b-form-input
                      :disabled="readonly || shipment_detail.isPOL_VN"
                      class="iuput"
                      v-model="shipment_detail.door_pick_up_input"
                      type="text"
                      placeholder="Pick up address"
                      required
                    ></b-form-input>
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="0" lg="2"></b-col>
              <b-col cols="6" lg="5">
                <validation-provider
                  name="Delivery address"
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <label class="flex"
                      >Delivery address <span class="red">*</span>
                    </label>

                    <b-form-input
                      :disabled="readonly || shipment_detail.isPOD_VN"
                      class="iuput"
                      v-model="shipment_detail.door_delivery_input"
                      type="text"
                      placeholder="Delivery address"
                      required
                    ></b-form-input>
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col class="mt-2" cols="6" lg="5">
                <b-row>
                  <label class="mx-1">Contact person</label>
                </b-row>
                <b-row>
                  <b-col class="pr-0" lg="3"
                    ><validation-provider
                      name="pick_up name"
                      #default="{ errors }"
                      rules=""
                    >
                      <b-form-group>
                        <b-form-input
                          :disabled="readonly || shipment_detail.isPOL_VN"
                          class="iuput"
                          v-model="shipment_detail.door_contact_pick_up.name"
                          type="text"
                          placeholder="Name"
                          required
                        ></b-form-input>
                        <small class="text-danger" v-show="errors.length > 0">{{
                          errors[0]
                        }}</small>
                      </b-form-group>
                    </validation-provider></b-col
                  >
                  <b-col class="pr-0" lg="4"
                    ><validation-provider
                      name="pick_up phone"
                      #default="{ errors }"
                      rules=""
                    >
                      <b-form-group>
                        <b-form-input
                          :disabled="readonly || shipment_detail.isPOL_VN"
                          class="iuput"
                          v-model="shipment_detail.door_contact_pick_up.phone"
                          type="text"
                          placeholder="Phone"
                          required
                        ></b-form-input>
                        <small class="text-danger" v-show="errors.length > 0">{{
                          errors[0]
                        }}</small>
                      </b-form-group>
                    </validation-provider></b-col
                  >
                  <b-col lg="5"
                    ><validation-provider
                      name="pick_up email"
                      #default="{ errors }"
                      rules=""
                    >
                      <b-form-group>
                        <b-form-input
                          :disabled="readonly || shipment_detail.isPOL_VN"
                          class="iuput"
                          v-model="shipment_detail.door_contact_pick_up.email"
                          type="text"
                          placeholder="Email"
                          required
                        ></b-form-input>
                        <small class="text-danger" v-show="errors.length > 0">{{
                          errors[0]
                        }}</small>
                      </b-form-group>
                    </validation-provider></b-col
                  >
                </b-row>
              </b-col>
              <b-col cols="0" lg="2"></b-col>
              <b-col class="mt-2" cols="6" lg="5">
                <b-row>
                  <label class="mx-1">Contact person</label>
                </b-row>
                <b-row>
                  <b-col class="pr-0" lg="3"
                    ><validation-provider
                      name="delivery name"
                      #default="{ errors }"
                      rules=""
                    >
                      <b-form-group>
                        <b-form-input
                          :disabled="readonly || shipment_detail.isPOD_VN"
                          class="iuput"
                          v-model="shipment_detail.door_contact_delivery.name"
                          type="text"
                          placeholder="Name"
                          required
                        ></b-form-input>
                        <small class="text-danger" v-show="errors.length > 0">{{
                          errors[0]
                        }}</small>
                      </b-form-group>
                    </validation-provider></b-col
                  >
                  <b-col class="pr-0" lg="4"
                    ><validation-provider
                      name="delivery phone"
                      #default="{ errors }"
                      rules=""
                    >
                      <b-form-group>
                        <b-form-input
                          :disabled="readonly || shipment_detail.isPOD_VN"
                          class="iuput"
                          v-model="shipment_detail.door_contact_delivery.phone"
                          type="text"
                          placeholder="Phone"
                          required
                        ></b-form-input>
                        <small class="text-danger" v-show="errors.length > 0">{{
                          errors[0]
                        }}</small>
                      </b-form-group>
                    </validation-provider></b-col
                  >
                  <b-col lg="5"
                    ><validation-provider
                      name="delivery email"
                      #default="{ errors }"
                      rules=""
                    >
                      <b-form-group>
                        <b-form-input
                          :disabled="readonly || shipment_detail.isPOD_VN"
                          class="iuput"
                          v-model="shipment_detail.door_contact_delivery.email"
                          type="text"
                          placeholder="Email"
                          required
                        ></b-form-input>
                        <small class="text-danger" v-show="errors.length > 0">{{
                          errors[0]
                        }}</small>
                      </b-form-group>
                    </validation-provider></b-col
                  >
                </b-row>
              </b-col>
            </b-row>
            <b-row v-if="shipment_detail.inland">
              <div class="titleCustom mt-2">Shipment Details</div>
            </b-row>
            <b-row class="px-2 mt-2" v-if="shipment_detail.inland">
              <b-col cols="12" lg="12">
                <b-row>
                  <b-col cols="12" lg="5">
                    <b-row>
                      <b-col
                        lg="9"
                        class="pr-0"
                        v-if="!shipment_detail.inland_other1"
                      >
                        <validation-provider
                          name="Pick up address"
                          #default="{ errors }"
                          rules=""
                        >
                          <b-form-group>
                            <label>Pick up address </label>

                            <Select4
                              v-model="shipment_detail.pickup_location"
                              placeholder="Enter a previously used pick up address, or click OTHER to in put a new one"
                              :disabled="readonly || shipment_detail.isPOD_VN"
                              :options="{
                                isSearch: true,
                                value: 'id',
                                label: 'text',
                                data: locationsPickUp,
                                fields: [
                                  {
                                    field: 'abbreviations',
                                    label: 'Abbreviations',
                                  },
                                  {
                                    field: 'name',
                                    label: 'Location',
                                  },
                                  {
                                    field: 'address',
                                    label: 'Address',
                                  },
                                ],
                              }"
                            />
                          </b-form-group>
                        </validation-provider>
                      </b-col>
                      <b-col
                        lg="9"
                        class="pr-0"
                        v-if="shipment_detail.inland_other1"
                      >
                        <validation-provider
                          name="Pick up address"
                          #default="{ errors }"
                          rules=""
                        >
                          <b-form-group>
                            <label>Pick up address</label>

                            <b-form-input
                              :disabled="readonly || shipment_detail.isPOD_VN"
                              class="iuput"
                              v-model="shipment_detail.inland_pick_up_input"
                              type="text"
                              placeholder="Enter a previously used pick up address, or click OTHER to in put a new one"
                              required
                            ></b-form-input>
                            <small
                              class="text-danger"
                              v-show="errors.length > 0"
                              >{{ errors[0] }}</small
                            >
                          </b-form-group>
                        </validation-provider>
                      </b-col>
                      <b-col lg="3" class="flex items-center mt-1">
                        <div class="container-checkbox mt-other">
                          <input
                            :disabled="readonly || shipment_detail.isPOD_VN"
                            type="checkbox"
                            class="custom-checkbox-new"
                            v-model="shipment_detail.inland_other1"
                          />

                          <div>
                            <div class="text-black">Other</div>
                          </div>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="0" lg="2"></b-col>
                  <b-col cols="12" lg="5">
                    <b-row>
                      <b-col
                        lg="9"
                        class="pr-0"
                        v-if="!shipment_detail.inland_other2"
                      >
                        <validation-provider
                          name="Delivery address"
                          #default="{ errors }"
                          rules=""
                        >
                          <b-form-group
                            :key="shipment_detail.delivery_location"
                          >
                            <label>Delivery address </label>

                            <Select4
                              v-model="shipment_detail.delivery_location"
                              placeholder="Enter a previously used delivery address, or click OTHER to in put a new one"
                              :disabled="readonly || shipment_detail.isPOL_VN"
                              :options="{
                                isSearch: true,
                                value: 'id',
                                label: 'text',
                                data: locationsDelivery,
                                fields: [
                                  {
                                    field: 'abbreviations',
                                    label: 'Abbreviations',
                                  },
                                  {
                                    field: 'name',
                                    label: 'Location',
                                  },
                                  {
                                    field: 'address',
                                    label: 'Address',
                                  },
                                ],
                              }"
                            />
                            <small
                              class="text-danger"
                              v-show="errors.length > 0"
                              >{{ errors[0] }}</small
                            >
                          </b-form-group>
                        </validation-provider>
                      </b-col>
                      <b-col
                        lg="9"
                        class="pr-0"
                        v-if="shipment_detail.inland_other2"
                      >
                        <validation-provider
                          name="Delivery address"
                          #default="{ errors }"
                          rules=""
                        >
                          <b-form-group>
                            <label>Delivery address</label>

                            <b-form-input
                              :disabled="readonly || shipment_detail.isPOL_VN"
                              class="iuput"
                              v-model="shipment_detail.inland_delivery_input"
                              type="text"
                              placeholder="Enter a previously used delivery address, or click OTHER to in put a new one"
                              required
                            ></b-form-input>
                            <small
                              class="text-danger"
                              v-show="errors.length > 0"
                              >{{ errors[0] }}</small
                            >
                          </b-form-group>
                        </validation-provider>
                      </b-col>
                      <b-col lg="3" class="flex items-center mt-1">
                        <div class="container-checkbox mt-other">
                          <input
                            :disabled="readonly || shipment_detail.isPOL_VN"
                            type="checkbox"
                            class="custom-checkbox-new"
                            v-model="shipment_detail.inland_other2"
                          />

                          <div>
                            <div class="text-black">Other</div>
                          </div>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="12" lg="12" class="mt-1">
                <b-row>
                  <b-col cols="12" lg="4">
                    <b-row>
                      <b-col lg="8" class="pr-0"
                        ><b-form-group>
                          <label>Pick up date</label>
                          <date-picker
                            :disabled="readonly || shipment_detail.isPOD_VN"
                            ref="datePicker"
                            v-model="shipment_detail.inland_pick_up_date"
                            type="date"
                            title-format="DD/MM/YY"
                            time-title-format="DD/MM/YY"
                            placeholder="Select date"
                            format="DD/MM/YY"
                            class="w-full"
                            value-type="format"
                          >
                          </date-picker> </b-form-group
                      ></b-col>
                      <b-col lg="4" class="mt-time"
                        ><b-form-group>
                          <date-picker
                            :disabled="readonly || shipment_detail.isPOD_VN"
                            v-model="shipment_detail.inland_pick_up_time"
                            ref="datePicker"
                            type="time"
                            title-format="HH:mm"
                            time-title-format="HH:mm"
                            placeholder="Select time"
                            format="HH:mm"
                            class="w-full"
                            value-type="format"
                          >
                          </date-picker> </b-form-group
                      ></b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="12" lg="3"></b-col>
                  <b-col cols="12" lg="4">
                    <b-row>
                      <b-col lg="8" class="pr-0"
                        ><b-form-group>
                          <label>Delivery date</label>
                          <date-picker
                            :disabled="readonly || shipment_detail.isPOL_VN"
                            ref="datePicker"
                            v-model="shipment_detail.inland_delivery_date"
                            type="date"
                            title-format="DD/MM/YY"
                            time-title-format="DD/MM/YY"
                            placeholder="Select date"
                            format="DD/MM/YY"
                            class="w-full"
                            value-type="format"
                          >
                          </date-picker> </b-form-group
                      ></b-col>
                      <b-col lg="4" class="mt-time"
                        ><b-form-group>
                          <label></label>
                          <date-picker
                            :disabled="readonly || shipment_detail.isPOL_VN"
                            v-model="shipment_detail.inland_delivery_time"
                            ref="datePicker"
                            type="time"
                            title-format="HH:mm"
                            time-title-format="HH:mm"
                            placeholder="Select time"
                            format="HH:mm"
                            class="w-full"
                            value-type="format"
                          >
                          </date-picker></b-form-group
                      ></b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="12" class="mt-1" lg="4"
                ><b-row>
                  <label class="mx-1">Contact person </label>
                </b-row>
                <b-row>
                  <b-col class="pr-0" lg="3"
                    ><validation-provider
                      name="inland_pick_up name"
                      #default="{ errors }"
                      rules=""
                    >
                      <b-form-group>
                        <b-form-input
                          :disabled="readonly || shipment_detail.isPOD_VN"
                          class="iuput"
                          v-model="shipment_detail.inland_contact_pick_up.name"
                          type="text"
                          placeholder="Name"
                          required
                        ></b-form-input>
                        <small class="text-danger" v-show="errors.length > 0">{{
                          errors[0]
                        }}</small>
                      </b-form-group>
                    </validation-provider></b-col
                  >
                  <b-col class="pr-0" lg="4"
                    ><validation-provider
                      name="inland_pick_up phone"
                      #default="{ errors }"
                      rules=""
                    >
                      <b-form-group>
                        <b-form-input
                          :disabled="readonly || shipment_detail.isPOD_VN"
                          class="iuput"
                          v-model="shipment_detail.inland_contact_pick_up.phone"
                          type="text"
                          placeholder="Phone"
                          required
                        ></b-form-input>
                        <small class="text-danger" v-show="errors.length > 0">{{
                          errors[0]
                        }}</small>
                      </b-form-group>
                    </validation-provider></b-col
                  >
                  <b-col lg="5"
                    ><validation-provider
                      name="inland_pick_up email"
                      #default="{ errors }"
                      rules=""
                    >
                      <b-form-group>
                        <b-form-input
                          :disabled="readonly || shipment_detail.isPOD_VN"
                          class="iuput"
                          v-model="shipment_detail.inland_contact_pick_up.email"
                          type="text"
                          placeholder="Email"
                          required
                        ></b-form-input>
                        <small class="text-danger" v-show="errors.length > 0">{{
                          errors[0]
                        }}</small>
                      </b-form-group>
                    </validation-provider></b-col
                  >
                </b-row>
              </b-col>
              <b-col lg="3"></b-col>
              <b-col cols="12" class="mt-1" lg="4"
                ><b-row>
                  <label class="mx-1">Contact person</label>
                </b-row>
                <b-row>
                  <b-col class="pr-0" lg="3"
                    ><validation-provider
                      name="inland_contact_delivery name"
                      #default="{ errors }"
                      rules=""
                    >
                      <b-form-group>
                        <b-form-input
                          :disabled="readonly || shipment_detail.isPOL_VN"
                          class="iuput"
                          v-model="shipment_detail.inland_contact_delivery.name"
                          type="text"
                          placeholder="Name"
                          required
                        ></b-form-input>
                        <small class="text-danger" v-show="errors.length > 0">{{
                          errors[0]
                        }}</small>
                      </b-form-group>
                    </validation-provider></b-col
                  >
                  <b-col class="pr-0" lg="4"
                    ><validation-provider
                      name="inland_contact_delivery phone"
                      #default="{ errors }"
                      rules=""
                    >
                      <b-form-group>
                        <b-form-input
                          :disabled="readonly || shipment_detail.isPOL_VN"
                          class="iuput"
                          v-model="
                            shipment_detail.inland_contact_delivery.phone
                          "
                          type="text"
                          placeholder="Phone"
                          required
                        ></b-form-input>
                        <small class="text-danger" v-show="errors.length > 0">{{
                          errors[0]
                        }}</small>
                      </b-form-group>
                    </validation-provider></b-col
                  >
                  <b-col lg="5"
                    ><validation-provider
                      name="inland_contact_delivery email"
                      #default="{ errors }"
                      rules=""
                    >
                      <b-form-group>
                        <b-form-input
                          :disabled="readonly || shipment_detail.isPOL_VN"
                          class="iuput"
                          v-model="
                            shipment_detail.inland_contact_delivery.email
                          "
                          type="text"
                          placeholder="Email"
                          required
                        ></b-form-input>
                        <small class="text-danger" v-show="errors.length > 0">{{
                          errors[0]
                        }}</small>
                      </b-form-group>
                    </validation-provider></b-col
                  >
                </b-row>
              </b-col>
            </b-row>
          </b-card>
          <b-card class="checkbox-bottom">
            <b-row class="px-2 custom-row">
              <b-col>
                <div class="container-checkbox">
                  <input
                    :disabled="readonly"
                    type="checkbox"
                    class="custom-checkbox-new-bottom"
                    id="checkbox-1"
                    v-model="shipment_detail.insurance"
                    name="checkbox-1"
                    value="accepted"
                    unchecked-value="not_accepted"
                  />

                  <div>
                    <div class="text-black">Insurance</div>
                  </div>
                </div>
              </b-col>
              <b-col>
                <div class="container-checkbox">
                  <input
                    :disabled="readonly"
                    type="checkbox"
                    class="custom-checkbox-new-bottom"
                    id="checkbox-1"
                    v-model="shipment_detail.packaging"
                    name="checkbox-1"
                    value="accepted"
                    unchecked-value="not_accepted"
                  />

                  <div>
                    <div class="text-black">Packaging</div>
                  </div>
                </div>
              </b-col>
              <b-col>
                <div class="container-checkbox">
                  <input
                    :disabled="readonly"
                    type="checkbox"
                    class="custom-checkbox-new-bottom"
                    id="checkbox-1"
                    v-model="shipment_detail.labeling"
                    name="checkbox-1"
                    value="accepted"
                    unchecked-value="not_accepted"
                  />

                  <div>
                    <div class="text-black">Labeling</div>
                  </div>
                </div>
              </b-col>

              <b-col>
                <div class="container-checkbox">
                  <input
                    :disabled="readonly"
                    type="checkbox"
                    class="custom-checkbox-new-bottom"
                    id="checkbox-1"
                    v-model="shipment_detail.securing_of_load"
                    name="checkbox-1"
                    value="accepted"
                    unchecked-value="not_accepted"
                  />

                  <div>
                    <div class="text-black">Fumigation</div>
                  </div>
                </div>
              </b-col>
              <b-col>
                <div class="container-checkbox">
                  <input
                    :disabled="readonly"
                    type="checkbox"
                    class="custom-checkbox-new-bottom"
                    id="checkbox-1"
                    v-model="shipment_detail.liquidation"
                    name="checkbox-1"
                    value="accepted"
                    unchecked-value="not_accepted"
                  />

                  <div>
                    <div class="text-black">Liquidation</div>
                  </div>
                </div>
              </b-col>
              <b-col>
                <div class="container-checkbox">
                  <input
                    :disabled="readonly"
                    type="checkbox"
                    class="custom-checkbox-new-bottom"
                    id="checkbox-1"
                    v-model="shipment_detail.commodity_policy"
                    name="checkbox-1"
                    value="accepted"
                    unchecked-value="not_accepted"
                  />

                  <div>
                    <div class="text-black">Commodity policy advisory</div>
                  </div>
                </div>
              </b-col>
              <b-col>
                <div class="container-checkbox">
                  <input
                    :disabled="readonly"
                    type="checkbox"
                    class="custom-checkbox-new-bottom"
                    id="checkbox-1"
                    v-model="shipment_detail.weighing"
                    name="checkbox-1"
                    value="accepted"
                    unchecked-value="not_accepted"
                  />

                  <div>
                    <div class="text-black">Weighing</div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </div>
        <div class="title custom-title mt-custom2">Notes</div>
        <div class="notes">
          <b-card class="note">
            <b-form-textarea
              :disabled="readonly"
              class="iuput custom-input"
              v-model="shipment_detail.notes"
              type="text"
              placeholder="Notes"
              required
            ></b-form-textarea>
          </b-card>
        </div>
        <!-- --- -->
        <!-- <b-row class="px-2 mb-2">
        <b-col cols="12" class="pt-1">
          <h4>Freight Informations</h4>
        </b-col>
        <b-col cols="12" lg="4">
          <validation-provider
            :name="shipment_detail.service_type == 1 ? 'AOL' : 'POL'"
            #default="{ errors }"
            rules="required"
          >
            <b-form-group>
              <label
                >{{ shipment_detail.service_type == 1 ? "AOL" : "POL"
                }}<font class="red">*</font>
              </label>

              <Select4
                v-model="shipment_detail.pol_port"
                :class="errors.length > 0 ? 'is-invalid' : null"
                placeholder="AOL/POL"
                :disabled="readonly"
                :options="{
                  value: 'code',
                  label: 'name',
                  data: ports,
                  fields: [
                    { field: 'code', label: 'Code' },
                    { field: 'name', label: 'Name' },
                    { field: 'type', label: 'Service' },
                    {
                      field: 'country_code',
                      label: 'Country Code',
                    },
                  ],
                }"
              />
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="4">
          <validation-provider
            :name="shipment_detail.service_type == 1 ? 'AOD' : 'POD'"
            #default="{ errors }"
            rules="required"
          >
            <b-form-group>
              <label
                >{{ shipment_detail.service_type == 1 ? "AOD" : "POD"
                }}<font class="red">*</font></label
              >

              
              <Select4
                v-model="shipment_detail.pod_port"
                :class="errors.length > 0 ? 'is-invalid' : null"
                placeholder="AOD/POL"
                :disabled="readonly"
                :options="{
                  value: 'code',
                  label: 'name',
                  data: ports,
                  fields: [
                    { field: 'code', label: 'Code' },
                    { field: 'name', label: 'Name' },
                    { field: 'type', label: 'Service' },
                    {
                      field: 'country_code',
                      label: 'Country Code',
                    },
                  ],
                }"
              />
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="4">
          <validation-provider
            name="Payment Terms"
            #default="{ errors }"
            rules=""
          >
            <b-form-group>
              <label>Payment Terms</label>
              <Select2
                :class="errors.length > 0 ? 'is-invalid' : null"
                :disabled="readonly"
                placeholder="Payment Terms"
                v-model="shipment_detail.paymentTerms"
                :options="$Options.paymentTerms"
              />
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        
        <b-col cols="12" lg="4">
          <validation-provider #default="{ errors }" rules="required">
            <label>Place of Receipt</label>

            <Select4
              v-model="shipment_detail.placeOfReceipt"
              :class="errors.length > 0 ? 'is-invalid' : null"
              placeholder="Place of Receipt"
              :disabled="readonly"
              :options="{
                value: 'code',
                label: 'name',
                data: ports,
                fields: [
                  { field: 'code', label: 'Code' },
                  { field: 'name', label: 'Name' },
                  { field: 'type', label: 'Service' },
                  {
                    field: 'country_code',
                    label: 'Country Code',
                  },
                ],
              }"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="4">
          <validation-provider #default="{ errors }" rules="required">
            <label>Place of Delivery</label>

            <Select4
              v-model="shipment_detail.placeOfDelivery"
              :class="errors.length > 0 ? 'is-invalid' : null"
              placeholder="Place of Delivery"
              :disabled="readonly"
              :options="{
                value: 'code',
                label: 'name',
                data: ports,
                fields: [
                  { field: 'code', label: 'Code' },
                  { field: 'name', label: 'Name' },
                  { field: 'type', label: 'Service' },
                  {
                    field: 'country_code',
                    label: 'Country Code',
                  },
                ],
              }"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="4">
          <validation-provider name="Carrier" #default="{ errors }" rules="">
            <b-form-group>
              <label>Carrier</label>

              <Select4
                v-model="shipment_detail.shipping_line"
                :class="[
                  errors.length > 0 ? 'is-invalid' : null,
                  readonly == true ? 'remove' : '',
                ]"
                placeholder="Carrier"
                :disabled="readonly"
                :options="{
                  value: 'id',
                  label: 'text',
                  data: shipping_lines,
                  fields: [
                    { field: 'code', label: 'Code' },
                    { field: 'name', label: 'Shipping Line' },
                  ],
                }"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>

       
        <b-col cols="12" lg="4">
          <validation-provider name="ETD" #default="{ errors }" rules="">
            <b-form-group>
              <label>ETD </label>
              <b-form-datepicker
                :state="errors.length > 0 ? false : null"
                :disabled="readonly"
                v-model="shipment_detail.etd"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }"
                locale="vi-VN"
              />
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="4">
          <validation-provider name="ETA" #default="{ errors }" rules="">
            <b-form-group>
              <label>ETA</label>
              <b-form-datepicker
                :state="errors.length > 0 ? false : null"
                v-model="shipment_detail.eta"
                :disabled="readonly"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }"
                locale="vi-VN"
              />
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col cols="12" lg="4">
          <validation-provider #default="{ errors }" rules="required">
            <label>B/L</label>
            <b-form-input
              :class="errors.length > 0 ? 'is-invalid' : null"
              v-model="shipment_detail.BL"
              :disabled="readonly"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-col>

        <b-col cols="12" class="pt-1">
          <h4>Cargo Information</h4>
        </b-col>

        <b-col cols="12" lg="4">
          <validation-provider
            name="Commodity"
            #default="{ errors }"
            rules="required"
          >
            <b-form-group>
              <label>Commodity<font class="red">*</font></label>
              <Select2
                :class="errors.length > 0 ? 'is-invalid' : null"
                :disabled="readonly"
                placeholder="Commodity"
                v-model="shipment_detail.goods_type"
                :options="goods_types"
              />
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="4">
          <validation-provider
            name="Commodity description"
            #default="{ errors }"
            rules=""
          >
            <b-form-group>
              <label>Commodity description</label>
              <b-form-input
                :state="errors.length > 0 ? false : null"
                :disabled="readonly"
                v-model="shipment_detail.mo_ta"
                placeholder="Commodity description"
              />
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="4">
          <validation-provider
            name="Gross Weight (kgs)"
            #default="{ errors }"
            rules=""
          >
            <b-form-group>
              <label>Total Gross Weight (kg)</label>

              <cleave
                :state="errors.length > 0 ? false : null"
                :options="$Utils.CONSTANTS.cleaveNumeral"
                :disabled="readonly"
                v-model="shipment_detail.trong_luong"
                class="form-control"
                placeholder="Gross Weight (kgs)"
              />
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="4">
          <b-form-group>
            <label>Measurement (cbm)</label>
            <b-form-input
              type="number"
              :disabled="readonly"
              v-model="shipment_detail.so_khoi"
              placeholder="Measurement (kgs)"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="4">
          <validation-provider
            name="Handled type"
            #default="{ errors }"
            rules=""
          >
            <b-form-group>
              <label>Handled type</label>
              <Select2
                :class="errors.length > 0 ? 'is-invalid' : null"
                :disabled="readonly"
                placeholder="Handled type"
                v-model="shipment_detail.handled_type"
                :options="handed_types"
              />
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col cols="12" lg="4">
          <validation-provider name="Dimension" #default="{ errors }" rules="">
            <b-form-group>
              <label>Dimension</label>
              <b-form-input
                :state="errors.length > 0 ? false : null"
                :disabled="readonly"
                v-model="shipment_detail.dimension"
                placeholder="Dimension"
              />
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="6">
          <validation-provider
            name="Package type"
            #default="{ errors }"
            rules=""
          >
            <b-form-group>
              <label>Package type</label>

              <Select2
                :class="errors.length > 0 ? 'is-invalid' : null"
                :disabled="readonly"
                placeholder="Package type"
                v-model="shipment_detail.package_type"
                :options="cont_types.filter((i) => i.group === 'packaging')"
              />
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col cols="12" lg="6">
          <validation-provider
            name="Package Number"
            #default="{ errors }"
            rules=""
          >
            <b-form-group>
              <label>Package Number</label>
              <b-form-input
                :state="errors.length > 0 ? false : null"
                :disabled="readonly"
                v-model="shipment_detail.packageNumber"
                placeholder="Package Number"
              />
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col cols="12" class="pt-1">
          <h4>Shipment Informations</h4>
        </b-col>
        <b-col cols="12" lg="6">
          <validation-provider name="Shipper" #default="{ errors }" rules="">
            <b-form-group>
              <label>Booking/HBL/INV</label>
              <b-form-input
                :disabled="readonly"
                placeholder="Booking/HBL/INV"
                v-model="shipment_detail.HBL"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="6">
          <validation-provider name="Shipper" #default="{ errors }" rules="">
            <b-form-group>
              <label>Shipping Type</label>
              <Select2
                :disabled="readonly"
                placeholder="Shipping Type"
                v-model="shipment_detail.shippingType"
                :options="
                  request_quotation.service_type == 5
                    ? transport_types.filter((i) => [1, 2, 3, 4].includes(i.id))
                    : request_quotation.service_type == 6
                    ? transport_types.filter((i) => [1, 2, 3, 4].includes(i.id))
                    : transport_types.filter((i) => [1, 2].includes(i.id))
                "
              />
            </b-form-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-col>

        <b-col cols="12" lg="4">
          <validation-provider name="Shipper" #default="{ errors }" rules="">
            <b-form-group>
              <label>Shipper </label>
              <div class="d-flex">
                <Select3
                  v-model="shipment_detail.shipper"
                  :disabled="readonly"
                  @select="
                    ({ name, Address }) => {
                      shipment_detail.shipper_name = name;
                      shipment_detail.shipper_address = Address;
                    }
                  "
                  :options="{
                    value: 'id',
                    label: 'name',
                    url: 'masterData?data=ShipperConsignee',
                    fields: [
                      { field: 'name', label: 'Name' },
                      {
                        field: 'Address',
                        label: 'Address',
                      },
                    ],
                  }"
                />
              </div>

              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="4">
          <validation-provider name="Consignee" #default="{ errors }" rules="">
            <b-form-group>
              <label>Consignee </label>

              <Select3
                v-model="shipment_detail.consignee"
                :disabled="readonly"
                @select="
                  ({ name, Address }) => {
                    shipment_detail.consignee_name = name;
                    shipment_detail.consignee_address = Address;
                  }
                "
                :options="{
                  value: 'id',
                  label: 'name',
                  url: 'masterData?data=ShipperConsignee',
                  fields: [
                    { field: 'name', label: 'Name' },
                    {
                      field: 'Address',
                      label: 'Address',
                    },
                  ],
                }"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="4">
          <validation-provider
            name="Company"
            #default="{ errors }"
            rules="required"
          >
            <b-form-group>
              <label>Agent </label>

              <Select4
                v-model="shipment_detail.agent"
                :disabled="readonly"
                :class="errors.length > 0 ? 'is-invalid' : null"
                placeholder="Select Company"
                :options="{
                  value: 'code',
                  label: 'text',
                  data: companyItems,
                  fields: [
                    { field: 'code', label: 'Tax Code' },

                    { field: 'name', label: 'Name' },
                    {
                      field: 'acronym',
                      label: 'Acronym',
                    },
                  ],
                }"
              />
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col cols="12" lg="6" v-if="shipment_detail.has_van_trucking">
          <validation-provider name="Truck Type" #default="{ errors }" rules="">
            <b-form-group>
              <label>Truck Type</label>
              <Select2
                :class="errors.length > 0 ? 'is-invalid' : null"
                :disabled="readonly"
                placeholder="Truck Type"
                v-model="shipment_detail.truck_type"
                :options="cont_types.filter((i) => i.group === 'van truck')"
              />
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="6" v-if="shipment_detail.has_van_trucking">
          <validation-provider name="Quantity" #default="{ errors }" rules="">
            <b-form-group>
              <label>Quantity</label>
              <b-form-input
                placeholder="Quantity"
                type="number"
                :state="errors.length > 0 ? false : null"
                :disabled="readonly"
                v-model="shipment_detail.so_luong"
              />
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="6" v-if="shipment_detail.has_van_trucking">
          <validation-provider
            name="Pick up"
            #default="{ errors }"
            rules="required"
          >
            <b-form-group>
              <label>Pick up<font class="red">*</font></label>
              <div class="d-flex align-items-center">
                <Select4
                  :key="countRq"
                  v-model="shipment_detail.pickup_location"
                  v-if="!shipment_detail.isHideShows"
                  :classProp="errors.length > 0 ? 'is-invalid' : null"
                  placeholder="Pick up"
                  :disabled="readonly"
                  :options="{
                    value: 'id',
                    label: 'text',
                    data: locations,
                    fields: [
                      { field: 'abbreviations', label: 'Abbreviations' },
                      { field: 'name', label: 'Location' },
                      {
                        field: 'address',
                        label: 'Address',
                      },
                    ],
                  }"
                />
                <b-form-input
                  v-if="shipment_detail.isHideShows"
                  :state="errors.length > 0 ? false : null"
                  :disabled="readonly"
                  v-model="shipment_detail.other_pickup_location"
                  placeholder="Enter pick up "
                />
                <b-form-checkbox
                  :disabled="readonly"
                  v-on:change="hideShows"
                  v-model="shipment_detail.isHideShows"
                  class="check_input"
                  >Other
                </b-form-checkbox>
              </div>
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="6" v-if="shipment_detail.has_van_trucking">
          <validation-provider
            name="Delivery"
            #default="{ errors }"
            rules="required"
          >
            <b-form-group>
              <label>Delivery<font class="red">*</font></label>
              <div class="d-flex align-items-center">
                <Select4
                  :key="countRq"
                  v-model="shipment_detail.delivery_location"
                  v-if="!shipment_detail.isHideShowPk"
                  :classProp="errors.length > 0 ? 'is-invalid' : null"
                  placeholder="Delivery"
                  :disabled="readonly"
                  :options="{
                    value: 'id',
                    label: 'text',
                    data: locations,
                    fields: [
                      { field: 'abbreviations', label: 'Abbreviations' },
                      { field: 'name', label: 'Location' },
                      {
                        field: 'address',
                        label: 'Address',
                      },
                    ],
                  }"
                />
                <b-form-input
                  v-if="shipment_detail.isHideShowPk"
                  :state="errors.length > 0 ? false : null"
                  :disabled="readonly"
                  v-model="shipment_detail.other_delivery_location"
                  placeholder="Enter pick up"
                />
                <b-form-checkbox
                  :disabled="readonly"
                  v-on:change="hideShowsPk"
                  v-model="shipment_detail.isHideShowPk"
                  class="check_input"
                  >Other
                </b-form-checkbox>
              </div>
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="6" v-if="shipment_detail.has_van_trucking">
          <validation-provider
            name="PIC pick up"
            #default="{ errors }"
            rules=""
          >
            <b-form-group>
              <label>PIC pick up</label>
              <b-form-input
                placeholder="PIC pick up"
                :state="errors.length > 0 ? false : null"
                :disabled="readonly"
                v-model="shipment_detail.PICPickUp"
              />
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="6" v-if="shipment_detail.has_van_trucking">
          <validation-provider
            name="PIC Delivery"
            #default="{ errors }"
            rules=""
          >
            <b-form-group>
              <label>PIC Delivery</label>
              <b-form-input
                placeholder="PIC Delivery"
                :state="errors.length > 0 ? false : null"
                :disabled="readonly"
                v-model="shipment_detail.PICDelivery"
              />
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="6" v-if="shipment_detail.has_van_trucking">
          <validation-provider
            name="PIC pick up"
            #default="{ errors }"
            rules=""
          >
            <b-form-group>
              <label>Pick up date</label>

              <section>
                <date-picker
                  ref="datePicker"
                  v-model="shipment_detail.pick_up_date"
                  type="datetime"
                  class="w-full"
                  :disabled="readonly"
                  value-type="format"
                  title-format="DD-MM-YYYY"
                  time-title-format="DD-MM-YYYY"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Select datetime"
                  :show-time-panel="showTimePanel"
                  format="DD-MM-YYYY HH:mm"
                  @close="handleOpenChange"
                >
                  <template v-slot:footer>
                    <button class="mx-btn mx-btn-text" @click="toggleTimePanel">
                      {{ showTimePanel ? "Date" : "Time" }}
                    </button>
                  </template>
                </date-picker>
              </section>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="6" v-if="shipment_detail.has_van_trucking">
          <validation-provider
            name="PIC pick up"
            #default="{ errors }"
            rules=""
          >
            <b-form-group>
              <label>Delivery Date</label>

              <section>
                <date-picker
                  ref="datePicker"
                  v-model="shipment_detail.delivery_date"
                  :disabled-date="disabledRangeDelivery"
                  type="datetime"
                  class="w-full"
                  value-type="format"
                  :disabled="readonly"
                  :state="errors.length > 0 ? false : null"
                  title-format="DD-MM-YYYY"
                  time-title-format="DD-MM-YYYY"
                  placeholder="Select datetime"
                  :show-time-panel="showTimePanel"
                  format="DD-MM-YYYY HH:mm"
                  @close="handleOpenChange"
                >
                  <template v-slot:footer>
                    <button class="mx-btn mx-btn-text" @click="toggleTimePanel">
                      {{ showTimePanel ? "Date" : "Time" }}
                    </button>
                  </template>
                </date-picker>
              </section>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" v-if="shipment_detail.has_customs">
          <b-row>
            <b-col cols="12" class="pt-1">
              <h4>Customs declaration information</h4>
            </b-col>
            <b-col cols="12" lg="6">
              <b-form-group>
                <label>Customs type</label>
                <Select2
                  :disabled="readonly"
                  placeholder="Customs type"
                  v-model="shipment_detail.customs_type"
                  :options="customs_types"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="6">
              <validation-provider
                name="Business type"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label>Business type<font class="red">*</font></label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="Business type"
                    v-model="shipment_detail.business_type"
                    :options="business_types"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6">
              <validation-provider
                name="Place of Custom declaration"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label
                    >Place of Custom declaration<font class="red"
                      >*</font
                    ></label
                  >
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="shipment_detail.customs_addr"
                    placeholder="Place of Custom declaration"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6">
              <b-form-group>
                <label>HS Code</label>
                <b-form-input
                  :disabled="readonly"
                  v-model="shipment_detail.hs_code"
                  placeholder="HS Code"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row> -->
      </div>
    </validation-observer>
  </section>
</template>

<script>
import useJwt from "@/auth/jwt/useJwt";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Select2 from "v-select2-component";
import moment from "moment";
import { mapState, mapActions } from "vuex";
import mixins from "./mixin/mixin";
export default {
  mixins: [mixins],
  // props: {
  //   bookingId: {
  //     default:null,
  //   },
  //   request_quotation:{
  //     default:null
  //   },
  //   shipment_on_tms:{
  //     default:null
  //   },
  //   shipment_on_fast{}
  // },
  props: [
    "request_quotation",
    "shipment_on_tms",
    "shipment_on_fast",
    "shipment_details",
    "bookingId",
    "proc_code",
    "tempViewBooking",
  ],
  components: {
    ValidationProvider,
    Select2,
    ValidationObserver,
  },
  data() {
    return {
      checkFirst: false,
      showTextShipping: null,
      reload: 1,
      iconAdd: require("@/assets/images/icons/add.png"),
      iconRemove: require("@/assets/images/icons/iconRemove.png"),
      remove: require("@/assets/images/icons/remove.png"),
      userData: JSON.parse(localStorage.getItem("userData")),
      showTimePanel: false,
      showTimeRangePanel: false,
      isHideShow: false,
      isHideShowPk: false,
      maxFiles: false,
      isHideShowBookingEdit: false,
      isHideShowPkBookingEdit: false,
      companyAddress: null,
      companyTax: null,
      shipment_detail: {
        id: null,

        pick_up_date: null,
        delivery_date: null,
      },
      moment,
      useLocations: [],
    };
  },
  watch: {
    "shipment_detail.showAddMore": function (n, o) {
      if (o == null && !this.checkFirst) {
        // check this.shipment_detail.showAddMore length is not
        console.log(this.shipment_detail?.showAddMore);
        if (this.shipment_detail?.showAddMore) {
        }
        

        this.shipment_detail?.showAddMore?.forEach((element, index) => {
          element.orderDetailId = this.bookingId + this.pad(index + 1);
          element?.showAddMoreLine?.forEach((item, ix) => {
            item.orderBlockId = element.orderDetailId + this.pad(ix + 1);
          });

          element.lclLine3 = Array.from({ length: 1 }, (_, idx1) => ({
            truckId: element.orderDetailId + this.pad(idx1 + 1),
            pickup_location: "",
            delivery_location: "",
            pickup_date: null,
            delivery_date: null,
          }));
        });
      }
    },
  },
  computed: {
    ...mapState("masterData", [
      "ports",
      "cont_types",
      "goods_types",
      "transport_types",
      "regions",
      "deports_locations",
      "service_types",
      "business_types",
      "customs_types",
      "incoterms",
      "sales",
      "companyItems",
      "regions",
      "company_list",
      "shipping_lines",
      "customer_list_options",
      "handed_types",
      "quotations",
      "locations",
      "locationByUser",
    ]),
    company_list() {
      return this.companyItems;
    },
    readonly() {
      return (
        (this.request_quotation && this.request_quotation.accept_edit != 1) ||
        this.request_quotation.locked == 1 ||
        this.userData.userType == this.$Utils.CONSTANTS.USER_TYPE_O.Client ||
        this.userData.userType == this.$Utils.CONSTANTS.USER_TYPE_O.Client_Root
      );
    },
    locationsPickUp: function () {
      if (
        (this.shipment_details.isPOD_VN || this.shipment_details.isPOL_VN) &&
        this.$Utils.LCL_PICKUP_DELIVERY_POL_POD[
          this.shipment_details.isPOD_VN
            ? "1"
            : this.shipment_details.isPOL_VN
            ? "3"
            : ""
        ]
      ) {
        this.shipment_details.pickup_location = "";
        return this.locationByUser?.filter((e) =>
          this.$Utils.LCL_PICKUP_DELIVERY_POL_POD[
            this.shipment_details.isPOD_VN
              ? "1"
              : this.shipment_details.isPOL_VN
              ? "3"
              : ""
          ].includes(e.location_type_id.toString())
        );
      }

      return [];
    },
    locationsDelivery: function () {
      if (
        (this.shipment_details.isPOD_VN || this.shipment_details.isPOL_VN) &&
        this.$Utils.LCL_PICKUP_DELIVERY_POL_POD[
          this.shipment_details.isPOD_VN
            ? "2"
            : this.shipment_details.isPOL_VN
            ? "4"
            : ""
        ]
      ) {
        return this.locationByUser?.filter((e) =>
          this.$Utils.LCL_PICKUP_DELIVERY_POL_POD[
            this.shipment_details.isPOD_VN
              ? "2"
              : this.shipment_details.isPOL_VN
              ? "4"
              : ""
          ].includes(e.location_type_id.toString())
        );
      }
      return [];
    },
  },
  // ||this.request_quotation.status_id == 63
  created() {
    if (this.proc_code) {
      if (
        ["LCL_D2D_EXPORT", "LCL_EXPORT"].some((item1) =>
          this.proc_code.includes(item1)
        )
      ) {
        this.shipment_detail.shippingType = 2;
        this.showTextShipping = "To Export";
      }
      if (
        ["LCL_D2D_IMPORT", "LCL_IMPORT"].some((item1) =>
          this.proc_code.includes(item1)
        )
      ) {
        this.shipment_detail.shippingType = 1;
        this.showTextShipping = "To Import";
      }
    } else {
      // Xử lý khi proc_code không tồn tại hoặc undefined
    }
  },
  mounted() {
    if (this.request_quotation || this.shipment_details) {
      this.getUserLocation(this.request_quotation.customer_id);
      this.$store.dispatch("masterData/fetchLocationByUser", {
        customer_id: this.request_quotation.customer_id,
      });

      if (!this.isBlank(this.shipment_details)) {
        this.shipment_detail = this.shipment_details;
        if (!this.shipment_detail.HBL) {
          this.shipment_detail.HBL = this.request_quotation.HBL;
        }

        if (!this.shipment_detail.showAddMore) {
          this.shipment_detail.showAddMore = this.request_quotation.showAddMore;
          this.checkFirst = false;
        } else {
          this.checkFirst = true;
        }
        if (!this.shipment_detail.prepaid && !this.shipment_detail.collect) {
          this.shipment_detail.prepaid = this.request_quotation.prepaid;
          this.shipment_detail.collect = this.request_quotation.collect;
        }

        if (
          !this.shipment_detail.stack_able &&
          !this.shipment_detail.non_stack_able &&
          !this.shipment_detail.rotatable
        ) {
          this.shipment_detail.stack_able = this.request_quotation.stack_able;
          this.shipment_detail.non_stack_able =
            this.request_quotation.non_stack_able;
          this.shipment_detail.rotatable = this.request_quotation.rotatable;
        }
        if (!this.shipment_detail.oversize) {
          this.shipment_detail.oversize = this.request_quotation.oversize;
        }
        if (!this.shipment_detail.overweight) {
          this.shipment_detail.overweight = this.request_quotation.overweight;
        }
        if (!this.shipment_detail.has_customs) {
          this.shipment_detail.has_customs = this.request_quotation.has_customs;
        }
        if (!this.shipment_detail.door_service) {
          this.shipment_detail.door_service =
            this.request_quotation.door_service;
        }
        if (!this.shipment_detail.inland) {
          this.shipment_detail.inland = this.request_quotation.inland;
        }
        if (!this.shipment_detail.custom_service_other) {
          this.shipment_detail.custom_service_other =
            this.request_quotation.custom_service_other;
        }
        if (!this.shipment_detail.customs_type_input) {
          this.shipment_detail.customs_type_input =
            this.request_quotation.customs_type_input;
        }
        if (!this.shipment_detail.custom_place) {
          this.shipment_detail.custom_place =
            this.request_quotation.custom_place;
        }
        if (!this.shipment_detail.custom_hs_code) {
          this.shipment_detail.custom_hs_code =
            this.request_quotation.custom_hs_code;
        }
        if (!this.shipment_detail.door_pick_up_input) {
          this.shipment_detail.door_pick_up_input =
            this.request_quotation.door_pick_up_input;
        }
        if (!this.shipment_detail.door_delivery_input) {
          this.shipment_detail.door_delivery_input =
            this.request_quotation.door_delivery_input;
        }
        if (!this.shipment_detail.door_contact_pick_up) {
          this.shipment_detail.door_contact_pick_up =
            this.request_quotation.door_contact_pick_up;
        }
        if (!this.shipment_detail.door_contact_delivery) {
          this.shipment_detail.door_contact_delivery =
            this.request_quotation.door_contact_delivery;
        }
        if (!this.shipment_detail.inland_other1) {
          this.shipment_detail.inland_other1 =
            this.request_quotation.inland_other1;
        }
        if (!this.shipment_detail.pickup_location) {
          this.shipment_detail.pickup_location =
            this.request_quotation.pickup_location;
        }
        if (!this.shipment_detail.inland_pick_up_input) {
          this.shipment_detail.inland_pick_up_input =
            this.request_quotation.inland_pick_up_input;
        }
        if (!this.shipment_detail.delivery_location) {
          this.shipment_detail.delivery_location =
            this.request_quotation.delivery_location;
        }
        if (!this.shipment_detail.inland_pick_up_date) {
          this.shipment_detail.inland_pick_up_date =
            this.request_quotation.inland_pick_up_date;
        }
        if (!this.shipment_detail.inland_other2) {
          this.shipment_detail.inland_other2 =
            this.request_quotation.inland_other2;
        }
        if (!this.shipment_detail.inland_delivery_input) {
          this.shipment_detail.inland_delivery_input =
            this.request_quotation.inland_delivery_input;
        }
        if (!this.shipment_detail.inland_pick_up_time) {
          this.shipment_detail.inland_pick_up_time =
            this.request_quotation.inland_pick_up_time;
        }
        if (!this.shipment_detail.inland_delivery_date) {
          this.shipment_detail.inland_delivery_date =
            this.request_quotation.inland_delivery_date;
        }
        if (!this.shipment_detail.inland_delivery_time) {
          this.shipment_detail.inland_delivery_time =
            this.request_quotation.inland_delivery_time;
        }
        if (!this.shipment_detail.inland_contact_pick_up) {
          this.shipment_detail.inland_contact_pick_up =
            this.request_quotation.inland_contact_pick_up;
        }
        if (!this.shipment_detail.inland_contact_delivery) {
          this.shipment_detail.inland_contact_delivery =
            this.request_quotation.inland_contact_delivery;
        }
        if (!this.shipment_detail.insurance) {
          this.shipment_detail.insurance = this.request_quotation.insurance;
        }
        if (!this.shipment_detail.packaging) {
          this.shipment_detail.packaging = this.request_quotation.packaging;
        }
        if (!this.shipment_detail.labeling) {
          this.shipment_detail.labeling = this.request_quotation.labeling;
        }
        if (!this.shipment_detail.securing_of_load) {
          this.shipment_detail.securing_of_load =
            this.request_quotation.securing_of_load;
        }
        if (!this.shipment_detail.liquidation) {
          this.shipment_detail.liquidation = this.request_quotation.liquidation;
        }
        if (!this.shipment_detail.commodity_policy) {
          this.shipment_detail.commodity_policy =
            this.request_quotation.commodity_policy;
        }
        if (!this.shipment_detail.weighing) {
          this.shipment_detail.weighing = this.request_quotation.weighing;
        }
        if (!this.shipment_detail.quotation) {
          this.shipment_detail.quotation = this.request_quotation.quotation;
        }
        if (!this.shipment_detail.transit_port) {
          this.shipment_detail.transit_port =
            this.request_quotation.transit_port;
        }
        if (this.shipment_detail.cargo_closing_date) {
          this.tempViewBooking.cargo_closing_date =
            this.shipment_detail.cargo_closing_date;
        }
        if (this.shipment_detail.showAddMore) {
          this.tempViewBooking.showAddMore = this.shipment_detail.showAddMore;
        }
        if (this.shipment_detail.doc_cut_off_date) {
          this.tempViewBooking.doc_cut_off_date =
            this.shipment_detail.doc_cut_off_date;
        }
        if (this.shipment_detail.doc_cut_off_time) {
          this.tempViewBooking.doc_cut_off_time =
            this.shipment_detail.doc_cut_off_time;
        }
        if (this.shipment_detail.cargo_closing_time) {
          this.tempViewBooking.cargo_closing_time =
            this.shipment_detail.cargo_closing_time;
        }
        if (this.shipment_detail.prepaid) {
          this.tempViewBooking.prepaid = this.shipment_detail.prepaid;
          this.tempViewBooking.collect = false;
        }
        if (this.shipment_detail.collect) {
          this.tempViewBooking.collect = this.shipment_detail.collect;
          this.tempViewBooking.prepaid = false;
        }
        if (this.shipment_detail.stack_able) {
          this.tempViewBooking.stack_able = this.shipment_detail.stack_able;
          this.tempViewBooking.non_stack_able = false;
          this.tempViewBooking.rotatable = false;
        }
        if (this.shipment_detail.non_stack_able) {
          this.tempViewBooking.stack_able = false;
          this.tempViewBooking.non_stack_able =
            this.shipment_detail.non_stack_able;
          this.tempViewBooking.rotatable = false;
        }
        if (this.shipment_detail.rotatable) {
          this.tempViewBooking.stack_able = false;
          this.tempViewBooking.non_stack_able = false;
          this.tempViewBooking.rotatable = this.shipment_detail.rotatable;
        }
        if (this.shipment_detail.oversize) {
          this.tempViewBooking.oversize = this.shipment_detail.oversize;
        }
        if (this.shipment_detail.overweight) {
          this.tempViewBooking.overweight = this.shipment_detail.overweight;
        }
        if (this.shipment_detail.transit_port) {
          this.tempViewBooking.transit_port = this.shipment_detail.transit_port;
        }
        if (this.shipment_detail.mo_ta) {
          this.tempViewBooking.mo_ta = this.shipment_detail.mo_ta;
        }
        if (this.shipment_detail.etd) {
          this.tempViewBooking.etd = this.shipment_detail.etd;
        }
        if (this.shipment_detail.vessel) {
          this.tempViewBooking.vessel = this.shipment_detail.vessel;
        }
        this.shipment_detail.id = this.bookingId;
      } else {
        this.shipment_detail.id = this.bookingId;
        this.shipment_detail = this.request_quotation;
        if (this.request_quotation.cargo_closing_date) {
          this.tempViewBooking.cargo_closing_date =
            this.request_quotation.cargo_closing_date;
        }
        if (this.request_quotation.showAddMore) {
          this.tempViewBooking.showAddMore = this.request_quotation.showAddMore;
        }
        if (this.request_quotation.doc_cut_off_date) {
          this.tempViewBooking.doc_cut_off_date =
            this.request_quotation.doc_cut_off_date;
        }
        if (this.request_quotation.doc_cut_off_time) {
          this.tempViewBooking.doc_cut_off_time =
            this.request_quotation.doc_cut_off_time;
        }
        if (this.request_quotation.cargo_closing_time) {
          this.tempViewBooking.cargo_closing_time =
            this.request_quotation.cargo_closing_time;
        }
        if (this.request_quotation.prepaid) {
          this.tempViewBooking.prepaid = this.request_quotation.prepaid;
          this.tempViewBooking.collect = false;
        }
        if (this.request_quotation.collect) {
          this.tempViewBooking.collect = this.request_quotation.collect;
          this.tempViewBooking.prepaid = false;
        }
        if (this.request_quotation.stack_able) {
          this.tempViewBooking.stack_able = this.request_quotation.stack_able;
          this.tempViewBooking.non_stack_able = false;
          this.tempViewBooking.rotatable = false;
        }
        if (this.request_quotation.non_stack_able) {
          this.tempViewBooking.stack_able = false;
          this.tempViewBooking.non_stack_able =
            this.request_quotation.non_stack_able;
          this.tempViewBooking.rotatable = false;
        }
        if (this.request_quotation.rotatable) {
          this.tempViewBooking.stack_able = false;
          this.tempViewBooking.non_stack_able = false;
          this.tempViewBooking.rotatable = this.request_quotation.rotatable;
        }
        if (this.request_quotation.oversize) {
          this.tempViewBooking.oversize = this.request_quotation.oversize;
        }
        if (this.request_quotation.overweight) {
          this.tempViewBooking.overweight = this.request_quotation.overweight;
        }
        if (this.request_quotation.transit_port) {
          this.tempViewBooking.transit_port =
            this.request_quotation.transit_port;
        }
        if (this.request_quotation.mo_ta) {
          this.tempViewBooking.mo_ta = this.request_quotation.mo_ta;
        }
        if (this.request_quotation.etd) {
          this.tempViewBooking.etd = this.request_quotation.etd;
        }
        if (this.request_quotation.vessel) {
          this.tempViewBooking.vessel = this.request_quotation.vessel;
        }
        this.tempViewBooking.id = this.bookingId;
        this.shipment_detail.agent = this.shipment_on_fast?.agent;

        this.shipment_detail.service_type = this.request_quotation.service_type;
        this.shipment_detail.has_customs =
          this.request_quotation?.has_customs || false;

        this.shipment_detail.deport = this.request_quotation.deport;

        this.shipment_detail.cont_type = this.request_quotation.cont_type;

        this.shipment_detail.goods_type = this.request_quotation.goods_type;

        this.shipment_detail.trong_luong = this.request_quotation.trong_luong;

        this.shipment_detail.shipping_line =
          this.request_quotation.shipping_line;

        this.shipment_detail.BL =
          this.request_quotation.booking_on_fast_info?.ConfirmHBL || "";

        this.shipment_detail.container_no = this.request_quotation.container_no;

        this.shipment_detail.seal_no = this.request_quotation.seal_no;

        this.shipment_detail.business_type =
          this.request_quotation.business_type;

        this.shipment_detail.customs_addr = this.request_quotation.customs_addr;

        this.shipment_detail.hs_code = this.request_quotation.hs_code;

        this.shipment_detail.notes = this.request_quotation.notes;

        this.shipment_detail.billingInformation =
          this.request_quotation.billingInformation;
        this.shipment_detail.so_luong = this.request_quotation.so_luong;
        this.shipment_detail.customs_type = this.request_quotation.customs_type;

        this.shipment_detail.pickup_location =
          this.request_quotation.pickup_location || "";
        this.shipment_detail.delivery_location =
          this.request_quotation.delivery_location || "";

        this.shipment_detail.shipper = this.shipment_on_fast.shipper;
        this.shipment_detail.shipper_name = this.shipment_on_fast.shipper_name;
        this.shipment_detail.consignee = this.shipment_on_fast.consignee;
        this.shipment_detail.consignee_name =
          this.shipment_on_fast.consignee_name;
        this.shipment_detail.vessel = this.shipment_on_fast.vessel;
        this.shipment_detail.voyage = this.shipment_on_fast.voyage;

        this.shipment_detail.placeOfDelivery =
          this.shipment_on_fast.placeOfDelivery;

        this.shipment_detail.customer_id = this.request_quotation.customer_id;
        this.shipment_detail.customer_name =
          this.request_quotation.customer_name;
        this.shipment_detail.customer_phone =
          this.request_quotation.customer_phone;
        this.shipment_detail.customer_email =
          this.request_quotation.customer_email;

        this.shipment_detail.sale_id = this.request_quotation.sale_id;
        this.shipment_detail.sale_name = this.request_quotation.sale_name;
        this.shipment_detail.sale_phone = this.request_quotation.sale_phone;

        this.shipment_detail.sale_email = this.request_quotation.sale_email;
        this.shipment_detail.customer_company_id =
          this.request_quotation.company_id;
        this.shipment_detail.pick_up_date = this.request_quotation.pick_up_date;
        this.shipment_detail.delivery_date =
          this.request_quotation.delivery_date;

        this.shipment_detail.PICPickUp = this.request_quotation.PICPickUp;
        this.shipment_detail.PICDelivery = this.request_quotation.PICDelivery;
        this.shipment_detail.pol_port = this.request_quotation.pol_port;

        this.shipment_detail.pod_port = this.request_quotation.pod_port;
        this.shipment_detail.paymentTerms = this.request_quotation.paymentTerms;
        this.shipment_detail.cargo_ready = this.request_quotation.cargo_ready;

        this.shipment_detail.etd = this.request_quotation.etd;
        this.shipment_detail.eta = this.request_quotation.eta;
        this.shipment_detail.placeOfDelivery =
          this.request_quotation.placeOfDelivery;

        this.shipment_detail.placeOfReceipt =
          this.request_quotation.placeOfReceipt;
        this.shipment_detail.mo_ta = this.request_quotation.mo_ta;

        this.shipment_detail.so_khoi = this.request_quotation.so_khoi;
        this.shipment_detail.handled_type = this.request_quotation.handled_type;

        this.shipment_detail.dimension = this.request_quotation.dimension;

        this.shipment_detail.package_type = this.request_quotation.package_type;
        this.shipment_detail.packageNumber =
          this.request_quotation.packageNumber;
        this.shipment_detail.HBL = this.request_quotation.HBL
          ? this.request_quotation.HBL
          : "";
        this.shipment_detail.has_van_trucking =
          this.request_quotation.has_van_trucking;

        this.shipment_detail.showAddMore = this.request_quotation
          ?.showAddMore || [
          {
            id: 1,
            hasDelete: false,
            showAddMoreLine: [
              {
                id: 2,
                hasDelete: false,
                gross_weight: null,
                volume: null,
                packages: null,
                dimension: {
                  lenght: null,
                  width: null,
                  height: null,
                },
              },
            ],
            package_type: null,
            total_packages: 0,
            gross_weight_total: 0,
            volume_total: 0,
          },
        ];

        this.shipment_detail?.showAddMore?.forEach((element, index) => {
          element.orderDetailId = this.bookingId + this.pad(index + 1);
          //showAddMoreLine
          element?.showAddMoreLine?.forEach((item, ix) => {
            item.orderBlockId = element.orderDetailId + this.pad(ix + 1);
          });

          element.lclLine3 = Array.from({ length: 1 }, (_, idx1) => ({
            truckId: element.orderDetailId + this.pad(idx1 + 1),
            pickup_location: this.shipment_detail.pickup_location,
            delivery_location: this.shipment_detail.delivery_location,
            pickup_date: this.shipment_detail.pick_up_date,
            delivery_date: this.shipment_detail.delivery_date,
          }));
        });
      }
      if (
        this.shipment_detail &&
        this.company_list &&
        this.company_list.length > 0
      ) {
        const customerCompany = this.company_list.find(
          (item) => item.id === this.shipment_detail.customer_company_id
        );

        if (customerCompany) {
          this.companyAddress = customerCompany.address;
          this.companyTax = customerCompany.tax_code;
          this.reload++;
        } else {
          // Xử lý khi không tìm thấy đối tượng khớp với customer_company_id
          this.companyAddress = "";
          this.companyTax = "";
        }
      } else {
        // Xử lý khi shipment_detail hoặc company_list rỗng
        this.companyAddress = "";
        this.companyTax = "";
      }
      this.$store.commit(
        "masterData/SET_SHIPPING_DETAIL",
        this.shipment_detail
      );
    }
  },
  methods: {
    handleChangeAdditional() {
      if (this.shipment_detail.door_service) {
        this.shipment_detail.inland = true;
        this.shipment_detail.has_d2d_trucking = true;
      } else {
        this.shipment_detail.has_d2d_trucking = false;
      }
      if (this.shipment_detail.inland && !this.shipment_detail.door_service) {
        this.shipment_detail.has_van_trucking = true;
      } else if (!this.shipment_detail.inland) {
        this.shipment_detail.has_van_trucking = false;
      }
    },
    handleChangeRemark(checkboxNumber) {
      if (
        (this.shipment_detail.rotatable ||
          this.shipment_detail.non_stack_able) &&
        checkboxNumber === 1
      ) {
        this.shipment_detail.stack_able = true;
        this.shipment_detail.non_stack_able = false;
        this.shipment_detail.rotatable = false;
      } else if (
        (this.shipment_detail.stack_able || this.shipment_detail.rotatable) &&
        checkboxNumber === 2
      ) {
        this.shipment_detail.non_stack_able = true;
        this.shipment_detail.stack_able = false;
        this.shipment_detail.rotatable = false;
      } else if (
        (this.shipment_detail.non_stack_able ||
          this.shipment_detail.stack_able) &&
        checkboxNumber === 3
      ) {
        this.shipment_detail.rotatable = true;
        this.shipment_detail.stack_able = false;
        this.shipment_detail.non_stack_able = false;
      }
    },
    handleChange(id) {
      if (id === 1 && this.shipment_detail.collect) {
        this.shipment_detail.prepaid = true;
        this.shipment_detail.collect = false;
      } else if (id === 2 && this.shipment_detail.prepaid) {
        this.shipment_detail.collect = true;
        this.shipment_detail.prepaid = false;
      }
    },
    updateVolume(items) {
      const index = this.shipment_detail.showAddMore.findIndex(
        (item) => item === items
      );
      let total = 0;
      for (let i = 0; i < items.showAddMoreLine.length; i++) {
        total = Number(items.showAddMoreLine[i].volume) + Number(total);
      }
      this.shipment_detail.showAddMore[index].volume_total = total;
    },
    updateGrossWeight(items) {
      const index = this.shipment_detail.showAddMore.findIndex(
        (item) => item === items
      );
      let total = 0;
      for (let i = 0; i < items.showAddMoreLine.length; i++) {
        total = Number(items.showAddMoreLine[i].gross_weight) + Number(total);
      }
      this.shipment_detail.showAddMore[index].gross_weight_total = total;
    },
    updatePackages(items) {
      const index = this.shipment_detail.showAddMore.findIndex(
        (item) => item === items
      );
      let total = 0;
      for (let i = 0; i < items.showAddMoreLine.length; i++) {
        total = Number(items.showAddMoreLine[i].packages) + Number(total);
      }
      this.shipment_detail.showAddMore[index].total_packages = total;
    },
    handleAddCargo() {
      const randomID =
        Math.random().toString(36).substr(2, 9) + "-" + Date.now();
      const randomID2 =
        Math.random().toString(30).substr(1, 8) + "-" + Date.now();
      const newElement = {
        id: randomID,
        hasDelete: true,
        showAddMoreLine: [
          {
            id: randomID2,
            hasDelete: false,
            gross_weight: null,
            volume: null,
            packages: null,
            dimension: {
              lenght: null,
              width: null,
              height: null,
            },
          },
        ],
        total_packages: 0,
        gross_weight_total: 0,
        volume_total: 0,
      };
      this.shipment_detail.showAddMore.push(newElement);
    },
    handleDeleteCargo(id) {
      this.shipment_detail.showAddMore =
        this.shipment_detail.showAddMore.filter((item) => item.id !== id);
    },
    handleAddLine(id) {
      const randomID =
        Math.random().toString(36).substr(2, 9) + "-" + Date.now();
      const index = this.shipment_detail.showAddMore.findIndex(
        (item) => item.id === id
      );

      if (index !== -1) {
        this.shipment_detail.showAddMore[index].showAddMoreLine.push({
          id: randomID,
          hasDelete: true,
          gross_weight: null,
          volume: null,
          packages: null,
          orderBlockId:
            this.bookingId +
            this.pad(index + 1) +
            this.pad(
              this.shipment_detail.showAddMore[index].showAddMoreLine.length + 1
            ),
          dimension: {
            lenght: null,
            width: null,
            height: null,
          },
        });
      }
    },
    handleDeleteLine(id, id2) {
      for (let i = 0; i < this.shipment_detail.showAddMore.length; i++) {
        const currentObj = this.shipment_detail.showAddMore[i];
        if (currentObj.id === id) {
          for (let j = 0; j < currentObj.showAddMoreLine.length; j++) {
            const lineCurrent = currentObj.showAddMoreLine[j];
            if (lineCurrent.id === id2) {
              currentObj.total_packages -= lineCurrent.packages;
              currentObj.volume_total -= lineCurrent.volume;
              currentObj.gross_weight_total -= lineCurrent.gross_weight;
            }
          }

          currentObj.showAddMoreLine = currentObj.showAddMoreLine.filter(
            (item) => item.id !== id2
          );
        }
      }
    },
    disabledRangeDelivery: function (date) {
      if (this.shipment_detail.pick_up_date) {
        var mydate = moment(this.shipment_detail.pick_up_date, "DD/MM/YYYY");

        //format that date into a different format
        var now = moment(mydate).format("MM/DD/YYYY");

        return date < new Date(now);
      }
    },
    toggleTimePanel() {
      this.showTimePanel = !this.showTimePanel;
    },
    toggleTimeRangePanel() {
      this.showTimeRangePanel = !this.showTimeRangePanel;
    },
    handleCloseChange() {
      this.$refs.datePicker.popupVisible = false;
    },
    handleOpenChange() {
      this.showTimePanel = false;
    },
    handleRangeClose() {
      this.showTimeRangePanel = false;
    },
    hideShows: function () {
      this.isHideShow = !this.isHideShow;
      if (!this.isHideShow) {
        this.shipment_detail.pickup_location = "";
      }
    },
    hideShowsPk: function () {
      this.isHideShowPk = !this.isHideShowPk;
      if (!this.isHideShowPk) {
        this.shipment_detail.delivery_location = "";
      }
    },
    changeHideShows: function () {
      this.isHideShowBookingEdit = !this.isHideShowBookingEdit;
    },
    changeHideShowsPk: function () {
      this.isHideShowPkBookingEdit = !this.isHideShowPkBookingEdit;
    },
  },
};
</script>

<style lang="scss">
.shipment_detail_LCL {
  .bg-cargo {
    z-index: 10;
  }
  .mt-time {
    margin-top: 3.2rem;
  }
  .mt-other {
    margin-top: 2.3rem;
  }
  .mt-custom {
    margin-top: 6rem;
  }
  .mt-custom2 {
    margin-top: 10rem;
  }
  .custom-add-line {
    cursor: pointer;
  }
  .mt-10 {
    padding: 0;
    margin-top: 45px;
  }
  label {
    color: #000000;
    font-weight: 600;
    margin-top: 1.5rem;
  }
  .customTotal {
    width: 100%;
    background-color: #f2f2f2;
    display: flex;
    align-items: center;
    padding-left: 10px;
    height: 38px;
    border-radius: 5px;
    color: #000000;
  }
  .select2-selection--single .mx-input {
    border: none !important;
  }
  .custom-delete {
    :hover {
      opacity: 0.7;
    }
    cursor: pointer;
    position: absolute;
    top: 10px;
    right: 45px;
  }
  .form-control {
    border: none !important;
  }
  .mx-input {
    border: none !important;
  }
  .b-card-bg {
    padding-top: 30px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    height: auto;
    @media (max-width: 992px) {
      height: 450px;
    }
    .custom-grid {
      flex: 0 0 19.5%;
      max-width: 19.3%;
      @media (max-width: 992px) {
        flex: 0 0 50%;
        max-width: 50%;
        margin: 0 0px;
      }
      .flex {
        display: flex;
        gap: 5px;
      }
    }
    @media (max-width: 992px) {
      height: 450px;
    }
  }
  .cargo-detail {
    z-index: 10;
    position: relative;
  }
  .add-more-cargo {
    background-color: white;
    width: 100%;
    height: 100px;
    position: absolute;
    bottom: -85px;
    z-index: 1;
    display: flex;
    align-items: end;
    justify-content: start;
    .select-add {
      color: #28938d;
      position: absolute;
      cursor: pointer;
      font-size: medium;
      font-weight: 600;
      bottom: 20px;
      left: 40px;
    }
  }
  .select2-selection .select2-selection--single {
    border: none !important;
  }
  .select2-selection--single:before {
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAAAmElEQVQokZ3SwQ3CIBTG8X+7gI6BNzawq3jnoOyBMcEBOooj1BNXV3ACzDOSGEuL8CWEvPeR34lOebcFRkDulD31uQNDF2Nkdz1r4AZsGiDJE9DB2EcvUzB2Ev1TtGCDYDL0aduIJmxKi/67rURn2AysRI+/WBb8Ez0EY8dckQUL6CK2Ci6gpzXsHfmHpaO808q7S/FtjLwAmwh101zduSgAAAAASUVORK5CYII=") !important;
  }
  .select2-selection--single {
    border: none !important;
  }
  .custom-row-freight {
    align-items: baseline;
    justify-content: center;
  }
  .container-checkbox {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .custom-list-additional {
    display: flex;
    justify-content: space-around;
  }
  .w-full {
    width: 100%;
  }
  .form-group {
    margin-bottom: 0;
  }
  .shipment_detail_LCL {
    & .b-card-bg {
      padding-top: 0;
    }
  }
  .py-custom {
    padding: 3px 0px;
  }
  .pt-custom {
    margin-top: 3.2rem;
  }
  .b-card-bg {
    padding-top: 0;
    padding: 1rem;
    & .card-body {
      width: 100%;
      & .custom-row {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
      }
    }
  }
}
</style>
